<template>
  <v-container fluid>
    <div>
      <v-layout v-if="selectedBot.theme == 'seagull'" row wrap justify-end style="margin: 0">
        <v-btn
          color="primary"
          class="m-0"
          :href="`${config.shopUrl}ecommerce/${
            $route.name == 'allinonechat' ? $store.state.livechat.pageid : selectedBot.pageid
          }/?create_user=true&lang=${currentLang}&category=all&app=others&from=livechat`"
          target="_blank"
          ><v-icon class="mr-1" small>shopping_cart</v-icon> สร้างออเดอร์</v-btn
        >
      </v-layout>
      <h3 :class="`headline ${selectedBot.theme == 'seagull' ? 'mt-0' : ''} `">
        {{ $t('Order Summary') }}
      </h3>
      <div v-if="isTcpMainPage" class="py-3">
        <v-layout wrap>
          <v-flex xs12 sm6>
            <multiselect
              v-model="filterTcpPage"
              :options="tcpPageOptions"
              select-label
              selected-label
              placeholder="เลือกเพจ"
              label="page_name"
              style="margin-bottom: 4px"
              @input="handleChangeShop"
            ></multiselect>
          </v-flex>
        </v-layout>
      </div>
      <div v-if="isPowerbuyPage" class="py-3">
        <v-layout wrap>
          <v-flex>
            <div
              class="nav nav-tabs"
              style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
            >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterApp != 'all'"
                :color="filterApp != 'all' ? 'grey' : 'primary'"
                @click="filterApp = 'all'"
                >{{ $t('All') }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterApp != 'facebook'"
                :color="filterApp != 'facebook' ? 'grey' : 'primary'"
                @click="filterApp = 'facebook'"
                >{{ $t('facebook') }}
              </v-btn>
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterApp != 'line'"
                :color="filterApp != 'line' ? 'grey' : 'primary'"
                @click="filterApp = 'line'"
                >{{ $t('line') }}
              </v-btn>

              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterApp != 'instagram'"
                :color="filterApp != 'instagram' ? 'grey' : 'primary'"
                @click="filterApp = 'instagram'"
                >{{ $t('instagram') }}
              </v-btn>
            </div>
          </v-flex>
          <v-flex style="display: flex; justify-content: flex-end">
            <multiselect
              v-model="filterShop"
              placeholder="เลือกสาขา"
              label="branch"
              :options="powerbuyShopOptions"
              :show-labels="false"
              style="max-width: 300px"
              @input="handleChangeShop"
            ></multiselect>
          </v-flex>
        </v-layout>
      </div>
      <div class="mb-2">
        <date-filter
          v-model="selectedDate"
          :default-filter="'today'"
          :show-time="true"
          @changeDate="onSelectedDate"
        ></date-filter>

        <v-layout
          v-if="currentFilter == 'custom_date' || currentFilter == 'custom_time'"
          wrap
          class="mt-2"
        >
          <v-flex xs12 sm6>
            <span class="order_summary_datepicker">{{ $t('from') }}:</span>
            <v-layout wrap row class="mb-2">
              <v-flex xs8 class="form-control">
                <datepicker
                  v-model="selectedDate.start"
                  @selected="onSelectedStartDate"
                ></datepicker>
              </v-flex>
              <v-flex xs4 class="form-control">
                <v-dialog
                  ref="starttime"
                  v-model="showStartTimeDialog"
                  :return-value.sync="starttime"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <template #activator="{ on }">
                    <div class="pl-2 pr-2">
                      <input
                        v-model="starttime"
                        type="text"
                        readonly
                        placeholder="00:00"
                        v-on="on"
                      />
                    </div>
                  </template>
                  <v-time-picker v-if="showStartTimeDialog" v-model="starttime" full-width>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="showStartTimeDialog = false">
                      {{ $t('cancel') }}
                    </v-btn>
                    <v-btn
                      flat
                      color="primary"
                      @click="
                        $refs.starttime.save(starttime)
                        showStartTimeDialog = false
                        changeDate('custom_time')
                      "
                      >{{ $t('Confirm') }}</v-btn
                    >
                  </v-time-picker>
                </v-dialog>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm6>
            <span class="order_summary_datepicker">{{ $t('to') }}:</span>
            <v-layout wrap row class="mb-2">
              <v-flex xs8 class="form-control">
                <datepicker
                  v-model="selectedDate.end"
                  style
                  @selected="onSelectedEndDate"
                ></datepicker>
              </v-flex>
              <v-flex xs4 class="form-control">
                <v-dialog
                  ref="endtime"
                  v-model="showEndTimeDialog"
                  :return-value.sync="endtime"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <template #activator="{ on }">
                    <div class="pl-2 pr-2">
                      <input v-model="endtime" type="text" readonly placeholder="00:00" v-on="on" />
                    </div>
                  </template>
                  <v-time-picker v-if="showEndTimeDialog" v-model="endtime" full-width>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="showEndTimeDialog = false">
                      {{ $t('cancel') }}
                    </v-btn>
                    <v-btn
                      flat
                      color="primary"
                      @click="
                        $refs.endtime.save(endtime)
                        showEndTimeDialog = false
                        changeDate('custom_time')
                      "
                      >{{ $t('Confirm') }}</v-btn
                    >
                  </v-time-picker>
                </v-dialog>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 class="text-xs-right">
            <v-btn color="primary" small @click="loadSummary">{{ $t('Search') }}</v-btn>
          </v-flex>
        </v-layout>
      </div>
      <div v-if="loading" class="text-xs-center" style="min-height: 400px">
        <v-layout justify-center align-center row style="height: 400px">
          <v-flex>
            <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
          </v-flex>
        </v-layout>
      </div>
      <template v-else>
        <v-divider class="mt-3 mb-3"></v-divider>

        <v-layout wrap>
          <v-flex xs12>
            <div
              v-if="['foodguru'].includes(selectedBot.theme)"
              class="nav nav-tabs"
              style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
            >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterStatus != 'all'"
                :color="filterStatus != 'all' ? 'grey' : 'primary'"
                @click="changeStatus('all')"
                >{{ $t('All') }} {{ badge.all > 0 ? '(' + badge.all + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterStatus != 'Reviewing'"
                :color="filterStatus != 'Reviewing' ? 'grey' : 'primary'"
                @click="changeStatus('Reviewing')"
                >Reviewing {{ badge['Reviewing'] > 0 ? '(' + badge['Reviewing'] + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterStatus != 'Payment สำเร็จ'"
                :color="filterStatus != 'Payment สำเร็จ' ? 'grey' : 'primary'"
                @click="changeStatus('Payment สำเร็จ')"
                >Payment สำเร็จ
                {{ badge['Payment สำเร็จ'] > 0 ? '(' + badge['Payment สำเร็จ'] + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterStatus != 'เปิดบิลสำเร็จ'"
                :color="filterStatus != 'เปิดบิลสำเร็จ' ? 'grey' : 'primary'"
                @click="changeStatus('เปิดบิลสำเร็จ')"
                >เปิดบิลสำเร็จ
                {{ badge['เปิดบิลสำเร็จ'] > 0 ? '(' + badge['เปิดบิลสำเร็จ'] + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterStatus != 'ส่งของสำเร็จ'"
                :color="filterStatus != 'ส่งของสำเร็จ' ? 'grey' : 'primary'"
                @click="changeStatus('ส่งของสำเร็จ')"
              >
                ส่งของสำเร็จ
                {{ badge['ส่งของสำเร็จ'] > 0 ? '(' + badge['ส่งของสำเร็จ'] + ')' : '' }}
              </v-btn>
            </div>
            <div
              v-else-if="['dtac-gaming'].includes(selectedBot.type)"
              class="nav nav-tabs"
              style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
            >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterStatus != 'all'"
                :color="filterStatus != 'all' ? 'grey' : 'primary'"
                @click="changeStatus('all')"
                >{{ $t('All') }} {{ badge.all > 0 ? '(' + badge.all + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterStatus != 'paid'"
                :color="filterStatus != 'paid' ? 'grey' : 'primary'"
                @click="changeStatus('paid')"
                >จ่ายแล้ว {{ badge['paid'] > 0 ? '(' + badge['paid'] + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterStatus != 'refilled'"
                :color="filterStatus != 'refilled' ? 'grey' : 'primary'"
                @click="changeStatus('refilled')"
                >เติมแล้ว {{ badge['refilled'] > 0 ? '(' + badge['refilled'] + ')' : '' }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterStatus != 'modify'"
                :color="filterStatus != 'modify' ? 'grey' : 'primary'"
                @click="changeStatus('modify')"
                >แก้ไข {{ badge['modify'] > 0 ? '(' + badge['modify'] + ')' : '' }}</v-btn
              >
            </div>
            <div
              v-else-if="isCentralLive"
              class="nav nav-tabs"
              style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
            >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterCategoryStatus != 'all'"
                :color="filterCategoryStatus != 'all' ? 'grey' : 'primary'"
                @click="changeCategory({ name: 'all' })"
                >{{ $t('All') }}</v-btn
              >
              <v-btn
                v-for="category in categories"
                :key="category.id"
                small
                depressed
                class="ma-1"
                :outline="filterCategoryStatus != category.name"
                :color="filterCategoryStatus != category.name ? 'grey' : 'primary'"
                @click="changeCategory(category)"
                >{{ category.name }}</v-btn
              >
            </div>
            <div v-else-if="isTcpMainPage || isTcpSubpage">
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterStatus != 'all'"
                :color="filterStatus != 'all' ? 'grey' : 'primary'"
                @click="changeStatus('all')"
                >{{ $t('All') }} {{ tcpBadge.all > 0 ? '(' + tcpBadge.all + ')' : '' }}</v-btn
              >

              <template v-for="(tcpStatus, index) in Object.entries(tcpBadge)">
                <template v-if="tcpStatus[0] !== 'all'">
                  <v-btn
                    :key="index"
                    small
                    depressed
                    class="ma-1"
                    :outline="filterStatus != tcpStatus[0]"
                    :color="filterStatus != tcpStatus[0] ? 'grey' : 'primary'"
                    @click="changeStatus(tcpStatus[0])"
                    >{{ tcpStatus[0] }} {{ tcpStatus[1] > 0 ? `(${tcpStatus[1]})` : '' }}</v-btn
                  >
                </template>
              </template>
            </div>
            <template v-else-if="isNestle">
              <NestleFilterOrderStatus :value="filterStatus" @onChangeStatus="changeStatus" />
            </template>

            <div
              v-else
              class="nav nav-tabs"
              style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
            >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterStatus != 'all'"
                :color="filterStatus != 'all' ? 'grey' : 'primary'"
                @click="changeStatus('all')"
                >{{ $t('All') }} {{ badge.all > 0 ? '(' + badge.all + ')' : '' }}</v-btn
              >
              <template v-if="!['toacrm'].includes(selectedBot.theme)">
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  :outline="filterStatus != 'ordered'"
                  :color="filterStatus != 'ordered' ? 'grey' : 'primary'"
                  @click="changeStatus('ordered')"
                  >{{ $t('ordered') }}
                  {{ badge.ordered > 0 ? '(' + badge.ordered + ')' : '' }}</v-btn
                >
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  :outline="filterStatus != 'paid'"
                  :color="filterStatus != 'paid' ? 'grey' : 'primary'"
                  @click="changeStatus('paid')"
                  >{{ $t('paid') }} {{ badge.paid > 0 ? '(' + badge.paid + ')' : '' }}</v-btn
                >
              </template>
              <template v-else>
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  :outline="filterStatus != 'waiting'"
                  :color="filterStatus != 'waiting' ? 'grey' : 'primary'"
                  @click="changeStatus('waiting')"
                  >{{ $t('waiting') }}
                  {{ badge.waiting > 0 ? '(' + badge.waiting + ')' : '' }}</v-btn
                >
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  :outline="filterStatus != 'pending'"
                  :color="filterStatus != 'pending' ? 'grey' : 'primary'"
                  @click="changeStatus('pending')"
                  >{{ $t('pending') }}
                  {{ badge.pending > 0 ? '(' + badge.pending + ')' : '' }}</v-btn
                >
              </template>
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterStatus != 'shipped'"
                :color="filterStatus != 'shipped' ? 'grey' : 'primary'"
                @click="changeStatus('shipped')"
                >{{ $t('shipped') }} {{ badge.shipped > 0 ? '(' + badge.shipped + ')' : '' }}</v-btn
              >
              <template v-if="isSeagull">
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  :outline="filterStatus != 'packing'"
                  :color="filterStatus != 'packing' ? 'grey' : 'primary'"
                  @click="changeStatus('packing')"
                  >{{ $t('packing') }}
                  {{ badge.packing > 0 ? '(' + badge.packing + ')' : '' }}</v-btn
                >
              </template>

              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterStatus != 'canceled'"
                :color="filterStatus != 'canceled' ? 'grey' : 'primary'"
                @click="changeStatus('canceled')"
              >
                {{ $t('cancel') }}
                {{ badge.canceled > 0 ? '(' + badge.canceled + ')' : '' }}
              </v-btn>
            </div>
          </v-flex>

          <v-flex v-if="['toacrm'].includes(selectedBot.theme)" xs12 class="text-xs-right">
            <v-btn outline color="grey" class="mr-2" @click="handleExportTrackingOrderToacrm">
              <em class="fas fa-clipboard-list mr-1" />
              {{ $t('export_shipping_order') }}
            </v-btn>
            <span class="upload">
              <label
                for="importFile"
                style="
                  display: inline-block;
                  background: #ff706b;
                  color: white;
                  padding: 7px;
                  cursor: pointer;
                  font-size: 15px;
                "
              >
                <em class="fas fa-truck" />
                &nbsp;Import Tracking No.
              </label>
              <input
                id="importFile"
                type="file"
                style="display: none"
                @change="handleImportFileToacrm($event)"
              />
            </span>
          </v-flex>

          <v-flex xs12 sm12 class="text-xs-right">
            <div class="text-xs-right">
              <!-- v-if="selectedBot.pagetype !== 'enterprise' && selectedBot.shippop_status" -->
              <template v-if="selectedBot.theme == 'foodguru' && selectedBot.shippop_status">
                <v-layout style="display: inline-block">
                  <v-btn
                    color="#0b9dd1"
                    :loading="loadingShippop"
                    depressed
                    dark
                    style="display: inline-block; margin-right: -5px"
                    @click="shipWithShippop"
                  >
                    <v-icon class="mr-1">local_shipping</v-icon>ส่งกับ Shippop
                  </v-btn>
                  <v-menu offset-y>
                    <template #activator="{ on }">
                      <v-btn
                        color="grey"
                        dark
                        class="ml-0"
                        style="display: inline-block; border-radius: 0"
                        outline
                        icon
                        v-on="on"
                      >
                        <v-icon>arrow_drop_down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile :href="`/${currentLang}/template?tab=Shippop`">
                        <v-list-tile-title>{{ $t('ดูรายการที่เคยส่ง') }}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-layout>
                <v-layout style="display: inline-block">
                  <v-btn
                    v-if="selectedBot.zortout_is_active"
                    color="#e5c813"
                    :loading="loadingZortout"
                    depressed
                    dark
                    style="
                      display: inline-block;
                      margin-right: -5px;
                      border-radius: 20px 20px 20px 0px !important;
                    "
                    @click.stop="shipWithZortout"
                  >
                    <v-icon class="mr-1">local_shipping</v-icon>ส่งกับ Zortout
                  </v-btn>
                </v-layout>
              </template>

              <shipping-jt v-model="summary" :cb-all.sync="cbAll" @onRefresh="onRefresh">
              </shipping-jt>

              <template v-if="!['tcp'].includes(selectedBot.theme)">
                <VueCtkDateTimePicker
                  v-if="isTremendous"
                  no-value-to-custom-elem
                  only-date
                  no-header
                  no-button-now
                  auto-close
                  :color="$vuetify.theme.primary"
                  :style="{ display: 'inline-block', width: 'auto' }"
                  @input="handleSelectedOrdersShippingDateUpdate"
                >
                  <v-btn outline color="primary" :disabled="!cbAll.length">
                    <v-icon>schedule_send</v-icon>
                    {{ $t('shipping_date') }}
                  </v-btn>
                </VueCtkDateTimePicker>
                <PrintAllCoversMonobo
                  v-if="
                    [
                      '148831989096546',
                      '1229692217050821',
                      '135565533158593',
                      '488563718210335',
                      '799590883441878'
                    ].includes(selectedBot.pageid)
                  "
                  :orders="filterOrders"
                  :circle="false"
                  style="display: inline-block"
                  @onPrinCover="onPrinCover(true, $event)"
                ></PrintAllCoversMonobo>
                <PrintAllCoversCentral
                  v-if="$store.state.centralPage.includes(selectedBot.pageid)"
                  :orders.sync="filterOrders"
                  :circle="false"
                  style="display: inline-block"
                  @onPrinCover="onPrinCover(true, $event)"
                ></PrintAllCoversCentral>
                <PrintAllCoverToacrm
                  v-if="['toacrm'].includes(selectedBot.theme)"
                  :orders.sync="filterOrders"
                  :circle="false"
                  style="display: inline-block"
                  @onPrinCover="onPrinCover(false, $event)"
                ></PrintAllCoverToacrm>
                <PrintAbbreviatedTaxInvoice
                  v-if="['seagull'].includes(selectedBot.theme)"
                  :orders.sync="filterOrders"
                  :circle="false"
                  style="display: inline-block"
                  @onPrinCover="onPrinCover(false, $event)"
                ></PrintAbbreviatedTaxInvoice>
                <PrintAllCoverSeagull
                  v-if="['seagull'].includes(selectedBot.theme)"
                  :orders.sync="filterOrders"
                  :circle="false"
                  style="display: inline-block"
                  @onPrinCover="onPrinCover(false, $event)"
                ></PrintAllCoverSeagull>
                <print-all-covers
                  v-else
                  :orders.sync="filterOrders"
                  :circle="false"
                  style="display: inline-block"
                  @onPrinCover="onPrinCover(false, $event)"
                ></print-all-covers>
              </template>
              <span>
                <v-dialog
                  v-if="!['tcp'].includes(selectedBot.theme)"
                  v-model="isEditShop"
                  persistent
                  width="800"
                >
                  <template #activator="{ on }">
                    <v-btn color="grey" outline v-on="on">
                      <em class="fa fa-pencil-alt mr-1" />
                      {{ $t('Edit Shop') }}
                    </v-btn>
                  </template>
                  <v-card>
                    <div style="float: right" class="text-xs-right">
                      <v-btn icon @click="isEditShop = false">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </div>
                    <v-card-text>
                      <h3 class="title">{{ $t('Profile') }}</h3>
                      <shop-profile
                        :is-edit="true"
                        :show-address="true"
                        @onSave="isEditShop = false"
                      ></shop-profile>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text>
                      <h3 class="title">{{ $t('Shop address') }}</h3>
                      <shipping-address></shipping-address>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </span>
              <v-layout v-if="['toacrm'].includes(selectedBot.theme)" style="display: inline-block">
                <v-btn outline color="grey" class="mr-0" @click="handleExportOrderSummaryToacrm">
                  <em class="fas fa-file-export mr-1" />
                  {{ $t('export') }}
                </v-btn>
              </v-layout>
              <v-layout v-else style="display: inline-block">
                <v-btn
                  outline
                  color="grey"
                  class="mr-0"
                  style="border-right: 0; display: inline-block"
                  @click="exportOrderSummary"
                >
                  <em class="fas fa-file-export mr-1" />
                  {{ $t('export') }}
                </v-btn>
                <v-menu offset-y>
                  <template #activator="{ on }">
                    <v-btn
                      color="grey"
                      dark
                      style="display: inline-block; border-radius: 0; margin-left: -10px"
                      outline
                      icon
                      v-on="on"
                    >
                      <v-icon>arrow_drop_down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile @click="exportOrderSummary('merge')">
                      <v-list-tile-title>{{ $t('Export old format') }}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="exportOrderSummary('kerry')">
                      <v-list-tile-title>{{ $t('Export kerry format') }}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile
                      v-if="
                        [
                          '148831989096546',
                          '1229692217050821',
                          '135565533158593',
                          '488563718210335',
                          '799590883441878'
                        ].includes(selectedBot.pageid)
                      "
                      @click="exportOrderSummary('sap')"
                    >
                      <v-list-tile-title>{{ $t('Export SAP format') }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-layout>

              <template v-if="showImportTrackNo">
                <v-menu offset-y style="display: inline-block">
                  <template #activator="{ on }">
                    <v-btn
                      style="margin-top: 6px"
                      :loading="loading"
                      :disabled="loading"
                      outline
                      color="grey"
                      v-on="on"
                    >
                      <v-icon>fa fa-print</v-icon>
                      &nbsp;{{ $t('การจัดการเลขพัสดุ') }}
                      <v-icon>arrow_drop_down</v-icon>
                    </v-btn>
                  </template>
                  <v-list v-if="!loading">
                    <v-list-tile @click="exportTrackingOrder">
                      <v-list-tile-title>
                        <em class="fas fa-clipboard-list mr-2"></em
                        >{{ $t('Export Order No.') }}</v-list-tile-title
                      >
                    </v-list-tile>
                    <v-list-tile @click="onClickUploadButton">
                      <span class="upload">
                        <v-list-tile-title>
                          <em class="fas fa-truck"></em>
                          &nbsp;Import Tracking No.
                        </v-list-tile-title>
                      </span>
                      <input
                        id="importFile"
                        type="file"
                        style="display: none"
                        @change="handleImportFile($event)"
                      />
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </template>
              <v-btn
                v-tooltip.top="$t('Refresh')"
                fab
                outline
                color="primary"
                small
                @click="onRefresh"
              >
                <em class="fa fa-refresh" />
              </v-btn>
            </div>
          </v-flex>
        </v-layout>

        <!-- Tracking for Happy Noz -->
        <div
          v-if="['335283187311293', '265953191921619'].includes(selectedBot.pageid)"
          class="text-xs-right mb-2"
        >
          <div
            style="
              display: inline-block;
              background: color;
              color: #ff706b;
              border: 1px solid #ff706b;
              padding: 7px;
              cursor: pointer;
              font-size: 15px;
              margin-right: 4px;
            "
            @click="exportTrackingOrder"
          >
            <em class="fas fa-clipboard-list" />
            &nbsp;Export Order No.
          </div>
          <span class="upload">
            <label
              for="importFile"
              style="
                display: inline-block;
                background: #ff706b;
                color: white;
                padding: 7px;
                cursor: pointer;
                font-size: 15px;
              "
            >
              <em class="fas fa-truck" />
              &nbsp;Import Tracking No.
            </label>
            <input
              id="importFile"
              type="file"
              style="display: none"
              @change="handleImportFile($event)"
            />
          </span>
        </div>

        <div>
          <v-layout wrap>
            <v-flex xs12 sm4 class="form-control px-1">
              <input v-model="search" type="text" :placeholder="$t('Search')" />
            </v-flex>

            <v-flex sm4 class="px-1">
              <template v-if="!isTcpMainPage && !isTcpSubpage">
                <multiselect
                  v-if="shippingOptions.length"
                  v-model="shippingFilter"
                  label="name"
                  :options="filteredShipping"
                  :placeholder="$t('Shipping')"
                  track-by="value"
                  :multiple="true"
                  @input="changeShippingOption"
                >
                  <template slot="option" slot-scope="props">
                    <span class="option__title"
                      >{{ $t(props.option.name) }} ({{ props.option.count }})</span
                    >
                  </template>
                </multiselect>
              </template>
            </v-flex>

            <v-flex sm4 class="px-1">
              <multiselect
                v-if="filterPayment.length"
                v-model="paymentFilter"
                label="name"
                :options="filterPayment"
                :placeholder="$t('Payments')"
                track-by="value"
                :multiple="true"
                @input="changePaymentOption"
              >
                <template slot="option" slot-scope="props">
                  <span class="option__title"
                    >{{ $t(props.option.name) }} ({{ props.option.count }})</span
                  >
                </template>
              </multiselect>
            </v-flex>

            <template v-if="isTremendous">
              <v-flex xs12 sm4 class="form-control px-1">
                <multiselect
                  v-model="userStatus"
                  :options="statusOptions"
                  :placeholder="$t('Status')"
                  @select="changeSeagullSearch"
                  @remove="changeSeagullSearch"
                >
                </multiselect>
              </v-flex>
              <v-flex xs12 sm4 class="text-xs-center text-sm-right px-1">
                <multiselect
                  v-model="userTag"
                  :options="tagOptions"
                  :placeholder="$t('Tags')"
                  @select="changeSeagullSearch"
                  @remove="changeSeagullSearch"
                >
                </multiselect>
              </v-flex>
            </template>

            <v-flex xs12 class="text-xs-center text-sm-right">
              <template v-if="!searchLoading">
                <v-pagination
                  v-model="pageNumber"
                  :length="pageCount"
                  class="mb-2"
                  @input="onClickPageinate"
                ></v-pagination>
              </template>
            </v-flex>
          </v-layout>
          <div style>
            <template v-if="['toacrm'].includes(selectedBot.theme)">
              <template v-if="filterSummaryToacrm.length > 0">
                <v-layout>
                  <v-flex sm3>
                    <v-checkbox
                      id="cbAll"
                      v-model="checkboxAll"
                      :label="$t('Check all')"
                      style="display: inline-block; margin: 0"
                      color="primary"
                      @change="clickCbAll"
                    ></v-checkbox>
                  </v-flex>
                  <v-spacer />
                  <v-flex text-xs-right style="padding-right: 1em"></v-flex>
                  <v-flex v-if="!['lookchingiant'].includes(selectedBot.theme)" sm4>
                    <multiselect
                      v-model="status"
                      label="label"
                      :disabled="!cbAll.length"
                      :options="orderStatusOptions"
                      :allow-empty="true"
                      :searchable="false"
                      :placeholder="$t('Modify all status')"
                      select-label
                      selected-label
                      deselect-label
                      @select="onSelectOrderStatus"
                    ></multiselect>
                  </v-flex>
                </v-layout>
                <template v-for="(order, index) in filterSummaryToacrm">
                  <ToacrmSummaryItem
                    :key="'order_' + order.id + '_' + order.virual_timestamp"
                    v-model="filterSummaryToacrm[index]"
                    :cb-all.sync="cbAll"
                    :shipping-options="shippingOptions"
                    :show-product-detail="showProductDetail"
                    @assignCb="assignCb"
                    @updateOrder="updateOrder(order.id, $event)"
                    @onChangeStatus="onChangeStatus(order.id)"
                    @onShowProductDetail="onShowProductDetail"
                  ></ToacrmSummaryItem>
                </template>
              </template>
              <template v-else>
                <div class="text-xs-center" style="margin: 35px 0">
                  <template v-if="searchLoading">
                    <v-progress-circular
                      :size="50"
                      color="primary"
                      indeterminate
                    ></v-progress-circular>
                  </template>
                  <template v-else>
                    <img
                      src="/static/img/assets/ecommerce/empty_shopping_cart.png"
                      alt
                      style="width: 230px"
                    />
                    <h3 class="headline">{{ $t('No data') }}</h3>
                  </template>
                </div>
              </template>
            </template>
            <template v-else>
              <template v-if="filterSummary.length > 0">
                <v-layout>
                  <v-flex sm3>
                    <v-checkbox
                      id="cbAll"
                      v-model="checkboxAll"
                      :label="$t('Check all')"
                      style="display: inline-block; margin: 0"
                      color="primary"
                      @change="clickCbAll"
                    ></v-checkbox>
                  </v-flex>
                  <v-spacer />
                  <v-flex text-xs-right style="padding-right: 1em"></v-flex>
                  <v-flex v-if="!['lookchingiant', 'tcp'].includes(selectedBot.theme)" sm4>
                    <multiselect
                      v-model="status"
                      label="label"
                      :disabled="!cbAll.length"
                      :options="orderStatusOptions"
                      :allow-empty="true"
                      :searchable="false"
                      :placeholder="$t('Modify all status')"
                      select-label
                      selected-label
                      deselect-label
                      @select="onSelectOrderStatus"
                    ></multiselect>
                  </v-flex>
                </v-layout>

                <template v-for="(order, index) in filterSummary">
                  <template v-if="selectedBot.pageid == '114660513608160'">
                    <forex-summary-item
                      :key="'forex_order_' + index"
                      v-model="filterSummary[index]"
                      :cb-all.sync="cbAll"
                      :shipping-options="shippingOptions"
                      :show-product-detail="showProductDetail"
                      @assignCb="assignCb"
                      @updateOrder="updateOrder(order.id, $event)"
                      @onChangeStatus="onChangeStatus(order.id)"
                      @onShowProductDetail="onShowProductDetail"
                    ></forex-summary-item>
                  </template>
                  <template
                    v-else-if="
                      [
                        '148831989096546',
                        '1229692217050821',
                        '135565533158593',
                        '488563718210335',
                        '799590883441878'
                      ].includes(selectedBot.pageid)
                    "
                  >
                    <monobo-summary-item
                      :key="'monobo_order_' + order.id"
                      v-model="filterSummary[index]"
                      :cb-all.sync="cbAll"
                      :shipping-options="shippingOptions"
                      :show-product-detail="showProductDetail"
                      @assignCb="assignCb"
                      @updateOrder="updateOrder(order.id, $event)"
                      @onChangeStatus="onChangeStatus(order.id)"
                      @onShowProductDetail="onShowProductDetail"
                    ></monobo-summary-item>
                  </template>
                  <template v-else-if="['seagull'].includes(selectedBot.theme)">
                    <SeagullSummaryItem
                      :key="'order_' + order.id + '_' + order.virual_timestamp"
                      v-model="filterSummary[index]"
                      :cb-all.sync="cbAll"
                      :shipping-options="shippingOptions"
                      :show-product-detail="showProductDetail"
                      @assignCb="assignCb"
                      @updateOrder="updateOrder(order.id, $event)"
                      @onChangeStatus="onChangeStatus(order.id)"
                      @onShowProductDetail="onShowProductDetail"
                    ></SeagullSummaryItem>
                  </template>
                  <template v-else>
                    <summary-item
                      :key="'order_' + order.id + '_' + order.virual_timestamp"
                      v-model="filterSummary[index]"
                      :cb-all.sync="cbAll"
                      :shipping-options="shippingOptions"
                      :show-product-detail="showProductDetail"
                      @assignCb="assignCb"
                      @updateOrder="updateOrder(order.id, $event)"
                      @onChangeStatus="onChangeStatus(order.id)"
                      @onShowProductDetail="onShowProductDetail"
                    ></summary-item>
                  </template>
                </template>
                <div class="text-xs-right" style="padding-top: 10px">
                  <template v-if="!searchLoading">
                    <v-pagination
                      v-model="pageNumber"
                      :length="pageCount"
                      class="mb-2"
                      @input="onClickPageinate"
                    ></v-pagination>
                  </template>
                </div>
              </template>

              <template v-else>
                <div class="text-xs-center" style="margin: 35px 0">
                  <img
                    src="/static/img/assets/ecommerce/empty_shopping_cart.png"
                    alt
                    style="width: 230px"
                  />
                  <h3 class="headline">{{ $t('No data') }}</h3>
                </div>
              </template>
            </template>
          </div>
        </div>
      </template>
      <v-dialog v-model="showEditAddress" width="800" persistent>
        <v-card v-if="showEditAddress">
          <v-card-text>
            <div style="text-align: right">
              <v-btn icon @click="showEditAddress = false">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <label for="pageAddress">{{ $t('Shop Address') }}</label>
            <shipping-address></shipping-address>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <shippop-shipping
      :key="shippoptimestamp"
      v-model="showFilterShippopPackage"
      :orders="filterShippopPackages"
      @isEditShop="isEditShop = true"
    ></shippop-shipping>
    <v-dialog v-model="IsImportTrackingSuccess" width="570px" height="270px">
      <v-card>
        <div
          class="text-center"
          style="display: flex; flex-direction: column; justify-content: center"
        >
          <div style="font-size: 24px; margin: 30px">
            ระบบอัปเดตสถานะการสั่งซื้อ<br />
            และแจ้ง Tracking No. ไปยังลูกค้าสำเร็จแล้ว
          </div>
          <div style="margin-bottom: 20px">
            <img src="/static/img/assets/check_operation.png" width="68px" height="64px" />
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-if="showExportGroupOrders" v-model="showExportGroupOrders" width="1000" persistent>
      <v-card class="pa-2">
        <div class="text-xs-right">
          <v-btn icon @click="showExportGroupOrders = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <template v-if="badgeNumberByStatus">
            <v-layout row wrap>
              <template v-for="n in Math.ceil(badgeNumberByStatus / limitExport)">
                <v-flex :key="`group_${n}`" xs6 sm4 md4 lg2 class="pa-2 text-xs-center">
                  <div class="z-border-red py-3">
                    <v-icon x-large>folder_shared</v-icon>
                    <div small>
                      {{ ((n - 1) * limitExport + 1) | numberFormat }} -
                      <template v-if="n == Math.ceil(badgeNumberByStatus / limitExport)">
                        {{ badgeNumberByStatus | numberFormat }}
                      </template>
                      <template v-else>{{ (n * limitExport) | numberFormat }}</template>
                    </div>
                    <v-btn color="primary" small @click="onSelectedRangeOrders(n - 1)">{{
                      $t('Download')
                    }}</v-btn>
                  </div>
                </v-flex>
              </template>
            </v-layout>
          </template>
          <template v-else>
            <div class="text-xs-center my-5">
              <slot name="empty"> No data </slot>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="mb-5 mt-5"></div>
  </v-container>
</template>

<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'
import datepicker from 'vuejs-datepicker'

import api from '@/api'
import moment from 'moment'
import numeral from 'numeral'
import XLSX from 'xlsx'
import SummaryItem from './SummaryItem'
import ForexSummaryItem from './ForexSummaryItem'
import ToacrmSummaryItem from './ToacrmSummaryItem'
import MonoboSummaryItem from './MonoboSummaryItem'
import SeagullSummaryItem from './SeagullSummaryItem'
import Multiselect from 'vue-multiselect'
import PrintAllCovers from './PrintAllCovers.vue'
import PrintAllCoverToacrm from './PrintAllCoverToacrm.vue'
import PrintAllCoverSeagull from './PrintAllCoverSeagull.vue'
import PrintAllCoversMonobo from './PrintAllCoversMonobo.vue'
import PrintAllCoversCentral from './PrintAllCoversCentral.vue'
import ShopProfile from '@/components/view/setting/ecommerce/ShopProfile'

import ShippopShipping from './ShippopShipping.vue'
import ShippingAddress from '@/components/view/setting/ecommerce/ShippingAddress'

import DateFilter from '@/components/view/dashboard/DateFilter'

import { ACOMMERCE_STATUS_OPTIONS, STATUS_OPTIONS } from '@/constants/acommerce.js'
import { PAGE } from '@/constants/page.js'
import toaCrmApi from '@/api/toa-crm'
import { handleResponse, handleApiError } from '@/api/util'
import orderApi from '@/api/order'
import ShippingJt from '@/components/view/template/ecommerce/ShippingJt.vue'
import tcpApi from '@/api/tcp'
import config from '@/config'
import NestleFilterOrderStatus from '@/components/view/template/ecommerce/NestleFilterOrderStatus.vue'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import tremendousApi from '../../../../api/tremendous'
import PrintAbbreviatedTaxInvoice from './Seagull/PrintAbbreviatedTaxInvoice.vue'
import { debounce } from 'lodash'

export default {
  components: {
    datepicker,
    SummaryItem,
    ShopProfile,
    Multiselect,
    PrintAllCovers,
    PrintAllCoversCentral,
    PrintAllCoversMonobo,
    ForexSummaryItem,
    MonoboSummaryItem,
    SeagullSummaryItem,
    ShippopShipping,
    ShippingAddress,
    DateFilter,
    ToacrmSummaryItem,
    PrintAllCoverToacrm,
    PrintAllCoverSeagull,
    ShippingJt,
    NestleFilterOrderStatus,
    VueCtkDateTimePicker,
    PrintAbbreviatedTaxInvoice
  },
  filters: {
    formatdate: function (value) {
      return moment(value).format('YYYY/MM/DD h:mm:ss a')
    }
  },
  data: function () {
    return {
      loading: true,
      shippingFilter: [],
      shippingOptions: [],
      isEditShop: false,
      showEditAddress: false,
      cbAll: [],
      checkboxAll: false,
      pageNumber: 1,
      pagetmp: 1,
      size: 10,
      offset: 0,
      search: '',
      filterStatus: 'all',
      showStartTimeDialog: false,
      showEndTimeDialog: false,
      starttime: '00:00',
      endtime: '23:59',
      showProductDetail: '',
      selectedDate: {
        start: moment().format('YYYY-MM-DD 00:00'),
        end: moment().format('YYYY-MM-DD 23:59')
      },
      summary: [],
      lang: {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ],
        pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
        placeholder: {
          date: 'Select Date',
          dateRange: 'Select Date Range'
        }
      },
      currentFilter: 'today',
      badge: {
        all: 0,
        canceled: 0,
        ordered: 0,
        paid: 0,
        shipped: 0,
        pending: 0,
        waiting: 0,
        packing: 0
      },
      categorybadgebadge: {
        all: 0,
        canceled: 0,
        ordered: 0,
        paid: 0,
        shipped: 0,
        pending: 0,
        waiting: 0,
        packing: 0
      },
      categories: [],
      status: '',
      filterCategoryStatus: 'all',
      loadingShippop: false,
      showFilterShippopPackage: false,
      filterShippopPackages: [],
      currentPaymentID: null,
      showPreview: false,
      paymentFilter: [],
      shippoptimestamp: moment().format('x'),
      IsImportTrackingSuccess: false,
      filterApp: 'all',
      filterShop: null,
      zortoutOrder: {
        status: '',
        loading: false,
        interval: null,
        show: false
      },
      loadingZortout: false,
      total: 0,
      showExportGroupOrders: false,
      limitExport: 5000,
      searchTimeout: null,
      searchLoading: false,
      filterTcpPage: '',
      tcpBadge: {},
      tagOptions: [],
      statusOptions: [],
      userTag: null,
      userStatus: null
    }
  },
  computed: {
    config() {
      return config
    },
    orderStatusOptions() {
      if (this.$store.state.nestlePages.some((page) => page.pageid == this.selectedBot.pageid)) {
        return ACOMMERCE_STATUS_OPTIONS.map((status) => ({
          label: this.$t(`ACOMMERCE_${status}`),
          value: status
        }))
      } else if (['toacrm'].includes(this.selectedBot.theme)) {
        const options = [
          {
            label: 'รอดำเนินการ',
            value: 'waiting'
          },
          {
            label: 'รอการจัดส่ง',
            value: 'pending'
          },
          {
            label: 'จัดส่งแล้ว',
            value: 'shipped'
          },
          {
            label: 'ยกเลิกการจัดส่ง',
            value: 'canceled'
          }
        ]
        return options
      } else if (['foodguru'].includes(this.selectedBot.theme)) {
        const options = [
          {
            label: 'Reviewing',
            value: 'Reviewing'
          },
          {
            label: 'Payment สำเร็จ',
            value: 'Payment สำเร็จ'
          },
          {
            label: 'เปิดบิลสำเร็จ',
            value: 'เปิดบิลสำเร็จ'
          },
          {
            label: 'ส่งของสำเร็จ',
            value: 'ส่งของสำเร็จ'
          }
        ]
        return options
      } else {
        return STATUS_OPTIONS.map((status) => ({
          ...status,
          label: this.$t(status.label)
        }))
      }
    },
    isNestle() {
      return this.$store.state.nestlePages.some((page) => page.pageid == this.selectedBot.pageid)
    },
    isCentralLive() {
      return this.$store.state.centralPage.includes(this.selectedBot.pageid)
    },
    // cbAll() {
    //   return this.summary.filter(v=> {
    //     return v.cb
    //   }).map( v => v.id )
    // },
    filteredShipping() {
      let vm = this
      var options = vm.shippingOptions.map((el) => {
        return {
          name: vm.$t(el.name),
          value: el.name,
          count: vm.summary.filter((v) => v.shippingtype == el.name).length
        }
      })

      options.push({
        name: vm.$t('Shippop'),
        value: 'shippop',
        count: vm.summary.filter((v) =>
          ['booking', 'waiting', 'confirm'].includes(v.shippop_status)
        ).length
      })

      return options
    },
    filterPayment() {
      return [
        {
          name: this.$t('Bank Transfer'),
          value: 'transfer',
          count: this.summary.filter((v) => v.payment == 'transfer' || v.payment == 'banktransfer')
            .length
        },
        {
          name: this.$t('cod_charge'),
          value: 'cod',
          count: this.summary.filter((v) => v.payment == 'cod').length
        },
        {
          name: this.$t('Qr Code'),
          value: 'qrcode',
          count: this.summary.filter((v) => v.payment == 'qrcode').length
        },
        {
          name: this.$t('Mobile Banking'),
          value: 'fbpay',
          count: this.summary.filter((v) => v.payment == 'fbpay').length
        },
        {
          name: this.$t('PayPal'),
          value: 'credit',
          count: this.summary.filter((v) => v.payment == 'credit').length
        },
        {
          name: this.$t('Credit card'),
          value: 'gbcredit',
          count: this.summary.filter((v) => v.payment == 'gbcredit').length
        }
      ].filter((el) => {
        return el.count > 0
      })
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      getPageProfile: 'getPageProfile',
      currentLang: 'currentLang',
      addresses: 'getShippingAddress'
    }),
    pageCount: function () {
      let l =
        Object.hasOwnProperty.call(this.badge, this.filterStatus) &&
        !isNaN(this.badge[this.filterStatus])
          ? this.badge[this.filterStatus]
          : this.filterSummary.length
      let s = this.size

      if (this.isTcpMainPage || this.tcpSubpages) {
        l = this.filterStatus === 'all' ? this.total : this.tcpBadge[this.filterStatus]
      }

      return Math.ceil(l / s)
    },
    filterSummaryToacrm() {
      const vm = this
      let orders = []
      let filter = []
      if (vm.search == '') {
        filter = vm.summary
      } else {
        filter = vm.summary.filter(function (el) {
          return (
            el.first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.id.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.productdetail.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.nameaddress.toLowerCase().includes(vm.search.toLowerCase()) ||
            (el.akita_order_ref &&
              el.akita_order_ref.toLowerCase().includes(vm.search.toLowerCase())) ||
            (el.shippop_tracking_code &&
              el.shippop_tracking_code.toLowerCase().includes(vm.search.toLowerCase())) ||
            (el.remark && el.remark.toLowerCase().includes(vm.search.toLowerCase()))
          )
        })
      }

      if (vm.shippingFilter.length) {
        filter = filter.filter((el) => {
          return vm.shippingFilter.some(
            (v) => (v.value == 'shippop' && el.shippop_status != null) || el.shippingtype == v.value
          )
        })
      }

      if (vm.paymentFilter.length) {
        filter = filter.filter((el) => {
          return vm.paymentFilter.some((v) => el.payment == v.value)
        })
      }

      orders = filter.filter((val) => {
        if (vm.filterCategoryStatus == 'all') return true
        else return val.livename == vm.filterCategoryStatus
      })

      return orders
    },
    filterSummary: function () {
      let vm = this
      let orders = []

      const filter = this.handleFilterOrderSummary()

      vm.countBadge(filter)

      orders = vm.handleFilterOrderByStatusAndCategory(filter)

      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size

      return ['toacrm', 'tcp'].includes(this.selectedBot.theme) ? orders : orders.slice(start, end)
    },
    filterSummaryAllPage: function () {
      let vm = this
      let orders = []
      let filter = []
      if (vm.search == '') {
        filter = vm.summary
      } else {
        filter = vm.summary.filter(function (el) {
          return (
            el.first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.id.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.productdetail.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.nameaddress.toLowerCase().includes(vm.search.toLowerCase())
          )
        })
      }

      if (vm.shippingFilter.length) {
        filter = filter.filter((el) => {
          return vm.shippingFilter.some((v) => el.shippingtype == v.value)
        })
      }

      vm.countBadge(filter)

      orders = vm.handleFilterOrderByStatusAndCategory(filter)

      return orders
    },

    filterOrders: function () {
      let vm = this
      let filter = this.summary

      if (vm.search == '') {
        if (vm.filterStatus !== 'all') {
          filter = filter.filter((el) => el.status == vm.filterStatus)
        }
      } else {
        if (!['tcp'].includes(this.selectedBot.theme)) {
          filter = vm.summary.filter(function (el) {
            return (
              el.first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
              el.last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
              el.id.toLowerCase().includes(vm.search.toLowerCase()) ||
              el.productdetail.toLowerCase().includes(vm.search.toLowerCase()) ||
              el.nameaddress.toLowerCase().includes(vm.search.toLowerCase())
            )
          })
        }
      }
      if (vm.shippingFilter.length) {
        filter = filter.filter((el) => {
          return vm.shippingFilter.some((v) => el.shippingtype == v.value)
        })
      }
      if (this.cbAll.length) {
        return filter.filter((el) => this.cbAll.includes(el.id))
      } else {
        return filter
      }
    },
    isPowerbuyPage() {
      return this.selectedBot.theme === 'powerbuy'
    },
    powerbuyShopOptions() {
      return this.$store.state.powerbuyBranchList
    },
    badgeNumberByStatus() {
      return this.badge[this.filterStatus]
    },
    isTremendous() {
      return PAGE.TREMENDOUS.includes(this.selectedBot.pageid)
    },
    showImportTrackNo() {
      return ['tero'].includes(this.selectedBot.theme)
    },
    isTcpMainPage() {
      return PAGE.TCP_MAIN_PAGE.includes(this.selectedBot.pageid)
    },
    isTcpSubpage() {
      return PAGE.TCP_SHOP_SERVICES.includes(this.selectedBot.pageid)
    },
    tcpPageOptions() {
      return this.$store.state.tcpSubpages || []
    },
    isYasale() {
      return (
        PAGE.YASALE.includes(this.selectedBot.pageid) && this.selectedBot.theme === 'ecommercebasic'
      )
    },
    isSeagull() {
      return (
        PAGE.SEAGULL.includes(this.selectedBot.pageid) &&
        ['seagull'].includes(this.selectedBot.theme)
      )
    }
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.pageNumber = 1
        this.clearSelectAll()
        if (['toacrm', 'tcp'].includes(this.selectedBot.theme)) {
          if (this.searchTimeout) {
            clearTimeout(this.searchTimeout)
          }
          // this.searchLoading = true
          this.searchTimeout = setTimeout(() => {
            this.onRefresh()
          }, 2000)
        }
      }
    }
  },
  async mounted() {
    this.loading = true
    // console.time('order')
    this.changeSeagullSearch = debounce(this.changeSeagullSearch, 300)
    let promiseOrderSummary = await this.getOrderSummary()
    let promiseShipping = this.getShipping()
    var orders = await promiseOrderSummary
    await promiseShipping

    if (this.isTremendous) {
      this.getUserTagList()
      this.getUserStatusList()
    }

    if (this.isTcpMainPage || this.isTcpSubpage) {
      await this.handleGetTcpOrderSummaryStatus()
    }

    this.convertOrder(orders)
    // console.timeEnd('order')
    this.loading = false
    await this.$store.dispatch('loadPageProfile')

    if (this.isCentralLive) {
      this.getCategories()
    }

    if (this.isTcpMainPage && !this.$store.state.tcpSubpages) {
      this.$store.dispatch('getTcpSubpages')
    }
  },

  methods: {
    async changeSeagullSearch() {
      var orders = await this.getOrderSummary()
      this.convertOrder(orders)
    },
    async getUserStatusList() {
      var response = await api.getUserStatusList()
      if (response && response.result) {
        response.result.map((item) => {
          this.statusOptions.push(item.name)
        })
      }
    },
    async getUserTagList() {
      var response = await api.getUserTagList()
      if (response && response.result) {
        response.result.map((item) => {
          this.tagOptions.push(item.name)
        })
      }
    },
    handleFilterOrderByStatusAndCategory(orders) {
      let result = orders.filter((val) => {
        if (this.filterStatus == 'all' || val.status == this.filterStatus) {
          return this.filterCategoryStatus == 'all' || val.livename == this.filterCategoryStatus
        } else {
          return false
        }
      })
      return result
    },
    countBadge(filter) {
      const vm = this
      if (vm.selectedBot.theme == 'toacrm' || this.isTcpMainPage || this.isTcpSubpage) {
        // Filter by backend
      } else {
        if (vm.selectedBot.theme == 'foodguru') {
          vm.badge = {
            all: 0,
            Reviewing: 0,
            'Payment สำเร็จ': 0,
            เปิดบิลสำเร็จ: 0,
            ส่งของสำเร็จ: 0
          }
        } else if (['dtac-gaming'].includes(this.selectedBot.type)) {
          vm.badge = {
            all: 0,
            paid: 0,
            refilled: 0,
            modify: 0
          }
        } else {
          vm.badge = {
            all: 0,
            canceled: 0,
            ordered: 0,
            paid: 0,
            shipped: 0,
            pending: 0,
            waiting: 0
          }
        }

        vm.badge.all = filter.length

        filter.forEach((val) => {
          if (vm.badge[val.status]) {
            vm.badge[val.status] += 1
          } else {
            vm.badge[val.status] = 1
          }
        })
      }
    },
    handleFilterOrderSummary() {
      const vm = this
      let filter = []
      if (vm.search == '') {
        filter = vm.summary
      } else {
        if (['tcp'].includes(vm.selectedBot.theme)) {
          filter = vm.summary
        } else {
          filter = vm.summary.filter(function (el) {
            return (
              el.first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
              el.last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
              el.id.toLowerCase().includes(vm.search.toLowerCase()) ||
              el.productdetail.toLowerCase().includes(vm.search.toLowerCase()) ||
              el.nameaddress.toLowerCase().includes(vm.search.toLowerCase()) ||
              (el.akita_order_ref &&
                el.akita_order_ref.toLowerCase().includes(vm.search.toLowerCase())) ||
              (el.shippop_tracking_code &&
                el.shippop_tracking_code.toLowerCase().includes(vm.search.toLowerCase())) ||
              (el.remark && el.remark.toLowerCase().includes(vm.search.toLowerCase()))
            )
          })
        }
      }

      if (vm.shippingFilter.length) {
        filter = filter.filter((el) => {
          return vm.shippingFilter.some(
            (v) => (v.value == 'shippop' && el.shippop_status != null) || el.shippingtype == v.value
          )
        })
      }

      if (vm.paymentFilter.length) {
        filter = filter.filter((el) => {
          return vm.paymentFilter.some((v) => el.payment == v.value)
        })
      }

      return filter
    },
    async handleExportOrderSummaryToacrm() {
      if (this.cbAll.length > 0) {
        this.exportOrderSummaryToacrm()
      } else {
        this.showExportGroupOrders = true
      }
    },
    getOrderExportList(offset) {
      const vm = this
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.selectedBot.pageid,
          datefrom: moment(vm.selectedDate.start).format('YYYY-MM-DD HH:mm'),
          dateto: moment(vm.selectedDate.end).format('YYYY-MM-DD HH:mm'),
          status: 'all',
          allcontents: false,
          limit: vm.limitExport,
          offset: offset
        }

        if (['toacrm'].includes(vm.selectedBot.theme)) {
          data.status = vm.filterStatus
        }

        api.getOrderSummary(data, function (error, response) {
          if (error) {
            console.error(error)
            reject()
            return
          }
          if (response.data) {
            resolve(response)
          }
        })
      })
    },

    async onSelectedRangeOrders(groupOrder) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const offset = groupOrder * vm.limitExport

        let orders = null

        if (['toacrm'].includes(vm.selectedBot.theme)) {
          orders = await vm.toacrmExportOrderSummary(offset)

          if (orders) {
            vm.exportOrderSummaryToacrm(orders)
          }
        } else {
          orders = await vm.getOrderExportList(offset)
          vm.convertOrder(orders)
        }

        vm.$store.dispatch('loading')
        vm.showExportGroupOrders = false
      } catch (error) {
        vm.$store.dispatch('loading')
        vm.showExportGroupOrders = false
        console.error(error)
      }
    },
    async exportOrderSummaryToacrm(data) {
      const vm = this
      try {
        let orders = []
        let filename = ''
        var json = []

        $.each(data, function (index, val) {
          if (val.status == vm.filterStatus) {
            orders.push(val)
          } else if (vm.filterStatus == 'all') {
            orders.push(val)
          }
        })

        orders = orders.filter((val) => {
          if (vm.filterCategoryStatus == 'all') return true
          else return val.livename == vm.filterCategoryStatus
        })
        // csvContent +=
        //   'Order No.,Status,SKU,Products,Price,Remark,Social Name,Real Name,Address,Price,Shipping,Tracking No.,Created Date,Status,Tags,Quantity' +
        //   '\r\n'
        orders = orders.sort(
          (a, b) =>
            moment(b.timestamp).format('YYYYMMDDHHmm') - moment(a.timestamp).format('YYYYMMDDHHmm')
        )
        $.each(orders, function (index, val) {
          let productdetail = []
          let products = null
          try {
            products = JSON.parse(val.productdetail)
          } catch (error) {
            products = val.productdetail
          }

          try {
            if (typeof products == 'object' && products.length > 0) {
              products.map(function (product) {
                productdetail.push({
                  name: product.name ? product.name : '',
                  quantity: product.quantity,
                  sku: product.sku ? product.sku : '',
                  option: product.option ? ' (' + product.option + ')' : '',
                  price: product.price > 0 ? product.price : 'Free',
                  cart_remark: product.cart_remark
                })
              })
            } else {
              productdetail[0] = val.productdetail
            }
          } catch (error) {
            productdetail[0] = val.productdetail
          }

          let shippingType = ''
          try {
            var jsondata = JSON.parse(val.shippingtype)
            if (jsondata.type) {
              shippingType = jsondata.type
            }
          } catch (error) {
            if (val.shippingtype.includes('other')) {
              var shipping = vm.shippingOptions.find((el) => {
                return el.name == val.shippingtype
              })
              shippingType = shipping ? shipping[4] : val.shippingtype
            } else {
              shippingType = val.shippingtype
            }
          }

          try {
            jsondata = JSON.parse(val.jsonvalue)
          } catch (error) {
            console.error(error)
          }

          let fullAddress = ''
          try {
            var nameaddress = JSON.parse(val.nameaddress)
            const subDistrictPrefix = nameaddress.province === 'กรุงเทพมหานคร' ? 'แขวง' : 'ตำบล'
            const districtPrefix = nameaddress.province === 'กรุงเทพมหานคร' ? 'เขต' : 'อำเภอ'
            fullAddress = `${nameaddress.address} ${subDistrictPrefix}${nameaddress.subDistrict} ${districtPrefix}${nameaddress.district} จังหวัด${nameaddress.province} ${nameaddress.postCode} เบอร์โทรศัพท์${nameaddress.phoneNumber}`
          } catch (error) {
            fullAddress = val.nameaddress
          }

          let row = {
            'Date & Time': moment(val.timestamp).format('DD/MM/YYYY HH:mm'),
            'Order Number': val.id,
            'Status Order': val.status,
            รหัสของรางวัล: products.sku,
            รายการของรางวัล: products.name,
            จำนวนคะแนนก่อนแลก: parseFloat(val.total),
            แลกคะแนน: products.points,
            คะแนนคงเหลือ:
              (val.total ? parseFloat(val.total) : 0) - (val.amount ? parseFloat(val.amount) : 0),
            Shipping: shippingType ? vm.$t(shippingType) : '',
            'Tracking No.': val.trackingno,
            Remark: val.remark != null ? val.remark : '',
            Channel: val.app,
            'Social Name': val.first_name + ' ' + val.last_name,
            ชื่อลูกค้า: nameaddress.name,
            Address: fullAddress
          }
          if (vm.selectedBot.theme == 'runkan') {
            Object.assign(row, {
              'Run status': val.runkanstatus == 'SUCCESS' ? 'วิ่งสำเร็จ' : 'วิ่งไม่สำเร็จ'
            })
          }

          json.push(row)

          if (productdetail.length > 1) {
            productdetail.map((detail, dindex) => {
              if (dindex != 0) {
                json.push({
                  SKU: detail.sku,
                  Products: `${detail.name}${detail.option ? ` ${detail.option}` : ''}`,
                  Price: numeral(detail.price).format('0,0.00'),
                  'SKU Amount': detail.quantity
                })
              }
            })
          }
        })
        filename = 'zwizshop'

        let dataWS = null
        dataWS = XLSX.utils.json_to_sheet(json)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, filename + '.xlsx')
      } catch (error) {
        console.error(error)
      }
    },
    async toacrmExportOrderSummary(offset) {
      const vm = this
      try {
        let data = {
          pageid: vm.selectedBot.pageid,
          datefrom: moment(vm.selectedDate.start).format('YYYY-MM-DD HH:mm'),
          dateto: moment(vm.selectedDate.end).format('YYYY-MM-DD HH:mm'),
          allcontents: false,
          limit: vm.limitExport,
          offset: offset,
          status: vm.filterStatus
        }

        const response = await toaCrmApi.getExportOrderSummary({ data: data })

        if (response && response.status === 200 && response.data && response.data.data) {
          return response.data.data
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    onShowProductDetail(payload) {
      this.showProductDetail = payload
    },
    async shipWithShippop() {
      var selected = this.summary.filter((el) => {
        return (
          this.cbAll.includes(el.id) &&
          ['ordered', 'paid'].includes(el.status) &&
          el.shippop_status == null
        )
      })
      if (selected.length == 0) {
        await this.$swal({
          title: 'กรุณาเลือกออเดอร์ที่ต้องการจัดส่ง',
          type: 'warning',
          confirmButtonText: this.$t('Confirm')
        })
      } else if (selected.length > 300) {
        await this.$swal({
          title: 'ไม่สามารถส่งกับทาง shippop เกิน 300 ออเดอร์ต่อหนึ่งการทำรายการ',
          type: 'warning',
          confirmButtonText: this.$t('Confirm')
        })
      } else {
        this.filterShippopPackages = selected
        this.shippoptimestamp = moment().format('x')
        await this.$nextTick()
        this.showFilterShippopPackage = true
      }
    },
    closePreview() {
      location.reload()
    },

    changeShippingOption() {
      this.clearSelectAll()
      this.pageNumber = 1
    },
    changePaymentOption() {
      this.clearSelectAll()
      this.pageNumber = 1
    },
    async onPrinCover(allcontents, payload) {
      var orders = []
      if (allcontents) {
        orders = await this.getOrderForExport()
      } else orders = this.filterOrders
      payload.printPdf(orders)
    },
    changeCategory(category) {
      this.filterCategoryStatus = category.name
      this.pageNumber = 1
    },
    getCategories() {
      const vm = this
      let data = {
        pageid: this.selectedBot.pageid
      }

      if (vm.isPowerbuyPage && vm.filterShop) {
        Object.assign(data, { shop_main_pageid: vm.filterShop.shop_main_pageid })
      }

      api.getCategories(data, (err, response) => {
        if (response.responsecode == 200) {
          this.categories = response.categorylist
        }
      })
    },
    async onRefresh() {
      this.loading = true

      if (this.isTcpMainPage || this.isTcpSubpage) {
        await this.handleGetTcpOrderSummaryStatus()
      }

      var orders = await this.getOrderSummary()
      this.convertOrder(orders)
      this.loading = false
      this.searchLoading = false
    },
    getShipping() {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = { pageid: vm.selectedBot.pageid }
        api.getAllShipingCharge(data, (error, response) => {
          if (error) reject(error)

          let result = Object.keys(response.shippinglist).map(function (key) {
            return { name: key, ...response.shippinglist[key] }
          })

          vm.shippingOptions = result
          vm.$store.state.shippinglist = response.shippinglist
          resolve()
        })
      })
    },
    assignCb(id) {
      if (this.cbAll.includes(id)) this.cbAll = this.cbAll.filter((v) => id != v)
      else {
        this.cbAll.push(id)
      }
    },
    clickCbAll() {
      if (!this.cbAll.length) {
        this.cbAll = this.filterSummaryAllPage.map((v) => v.id)
        this.checkboxAll = true
      } else {
        this.cbAll = []
        this.checkboxAll = false
      }
    },
    onSelectOrderStatus(status) {
      let vm = this

      var orders = this.summary
        .filter((el) => {
          // if (this.selectedBot.pagetype !== 'enterprise') {
          //   return this.cbAll.includes(el.id) && el.shippop_status == null
          // } else {
          return this.cbAll.includes(el.id)
          // }
        })
        .map((el) => {
          return el.id
        })

      if (orders.length == 0) {
        return false
      }
      let data = {
        status: status.value,
        orderid: orders,
        pageid: this.selectedBot.pageid
      }
      vm.$store.dispatch('loading')
      api.putmultistatusordersummary(data, async function (error) {
        if (error) return console.error(error)
        var promiseStatus = []
        vm.summary.forEach(async (el) => {
          if (vm.cbAll.includes(el.id)) {
            if (
              vm.selectedBot.pageid != '1227843817265057' &&
              !['toacrm'].includes(vm.selectedBot.theme)
            ) {
              if (status.value != 'canceled' && el.status == 'canceled') {
                promiseStatus.push(
                  new Promise((resolve) => {
                    api.orderstockdelete({ orderid: el.id }, () => {
                      resolve()
                    })
                  })
                )
              } else if (el.status != 'canceled' && status.value == 'canceled') {
                promiseStatus.push(
                  new Promise((resolve) => {
                    api.orderstockadd({ orderid: el.id }, () => {
                      resolve()
                    })
                  })
                )
              }
            }

            el.status = status.value
          }
        })
        await Promise.all(promiseStatus)
        vm.$store.dispatch('loading')
      })
    },
    onClickPageinate: function (pageNum) {
      const vm = this
      if (['toacrm', 'tcp'].includes(vm.selectedBot.theme)) {
        if (this.pagetmp !== pageNum) {
          this.pagetmp = pageNum
          vm.offset = vm.pageNumber * vm.size - vm.size
          vm.onRefresh()
        }
      } else {
        $('.vb-content').animate({
          scrollTop: 0
        })
      }
    },
    onSelectedDate: async function () {
      this.pageNumber = 1
      this.filterStatus = 'all'
      this.offset = 0
      this.loading = true

      if (this.isTcpMainPage || this.isTcpSubpage) {
        await this.handleGetTcpOrderSummaryStatus()
      }

      var orders = await this.getOrderSummary()
      this.convertOrder(orders)

      this.loading = false
    },
    onSelectedStartDate: async function (value) {
      this.pageNumber = 1
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(this.selectedDate.end).isBefore(value)) {
        this.selectedDate.end = value
      }
      this.selectedDate.start = value
    },
    onSelectedEndDate: async function (value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(value).isBefore(this.selectedDate.start)) {
        this.selectedDate.start = value
      }
      this.selectedDate.end = value
    },
    async loadSummary() {
      this.loading = true
      var orders = await this.getOrderSummary()
      this.convertOrder(orders)
      this.loading = false
    },
    changeStatus: function (value) {
      this.filterStatus = value
      this.pageNumber = 1
      this.offset = 0
      this.clearSelectAll()

      if (['toacrm'].includes(this.selectedBot.theme) || this.isTcpMainPage || this.isTcpSubpage) {
        this.loadSummary()
      }
    },
    async getOrderForExport() {
      let vm = this
      var response = await this.getOrderSummary(true, true)
      var orders = []
      if (response.data) {
        orders = response.data
      }
      let filter = orders

      if (vm.search == '') {
        if (vm.filterStatus !== 'all') {
          filter = filter.filter((el) => el.status == vm.filterStatus)
        }
      } else {
        filter = vm.summary.filter(function (el) {
          return (
            (el.first_name && el.first_name.toLowerCase().includes(vm.search.toLowerCase())) ||
            (el.last_name && el.last_name.toLowerCase().includes(vm.search.toLowerCase())) ||
            (el.id && el.id.toLowerCase().includes(vm.search.toLowerCase())) ||
            (el.productdetail &&
              el.productdetail.toLowerCase().includes(vm.search.toLowerCase())) ||
            (el.nameaddress && el.nameaddress.toLowerCase().includes(vm.search.toLowerCase()))
          )
        })
      }
      if (vm.shippingFilter.length) {
        filter = filter.filter((el) => {
          return vm.shippingFilter.some((v) => el.shippingtype == v.value)
        })
      }
      if (this.cbAll.length) {
        return filter.filter((el) => this.cbAll.includes(el.id))
      } else {
        return filter
      }
    },
    clearSelectAll() {
      this.cbAll = []
      this.checkboxAll = false
    },

    async handleGetTcpOrderSummaryStatus() {
      const vm = this
      try {
        const data = {
          status: 'all',
          start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
          end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD'),
          limit: vm.size,
          offset: vm.offset
        }

        if (vm.isTcpMainPage) {
          Object.assign(data, {
            master_page_id: vm.selectedBot.pageid,
            page_id: vm.filterTcpPage ? vm.filterTcpPage.page_id : vm.selectedBot.pageid
          })
        } else {
          Object.assign(data, {
            page_id: vm.selectedBot.pageid
          })
        }

        if (vm.search) {
          Object.assign(data, { search: vm.search })
        }

        const response = await tcpApi.postGetOrderSummaryStatus({ data })
        if (response && response.status === 200) {
          const tempData = response.data.data
          const countAll = Object.values(tempData).reduce(
            (accumulator, currentValue) => accumulator + currentValue
          )
          Object.assign(tempData, { all: countAll })
          this.tcpBadge = tempData
        }
      } catch (error) {
        console.error(error)
      }
    },

    getOrderSummary: async function (allcontents, noclearselect) {
      const vm = this
      allcontents = allcontents ? allcontents : false

      if (vm.isTcpMainPage || vm.isTcpSubpage) {
        try {
          const data = {
            status: vm.filterStatus !== 'all' ? vm.filterStatus : 'all',
            start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD '),
            end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD '),
            limit: vm.size,
            offset: vm.offset
          }

          if (vm.isTcpMainPage) {
            Object.assign(data, {
              master_page_id: vm.selectedBot.pageid,
              page_id: vm.filterTcpPage ? vm.filterTcpPage.page_id : vm.selectedBot.pageid
            })
          } else {
            Object.assign(data, {
              page_id: vm.selectedBot.pageid
            })
          }

          if (vm.search) {
            Object.assign(data, { search: vm.search })
          }

          const response = await tcpApi.postGetOrderSummary({ data })
          if (response && response.status === 200) {
            vm.total = response.data.total
              ? parseInt(response.data.total)
              : response.data.data.length
            return response.data
          } else {
            return null
          }
        } catch (error) {
          console.error(error)
          return null
        }
      } else {
        const addOnFilter = {}
        if (this.userTag) {
          addOnFilter.tag = this.userTag
        }
        if (this.userStatus) {
          addOnFilter.user_status = this.userStatus
        }
        return new Promise((resolve, reject) => {
          let data = {
            pageid: vm.selectedBot.pageid,
            datefrom: moment(vm.selectedDate.start).format('YYYY-MM-DD HH:mm'),
            dateto: moment(vm.selectedDate.end).format('YYYY-MM-DD HH:mm'),
            status: 'all',
            allcontents: allcontents,
            ...addOnFilter
          }

          if (vm.isPowerbuyPage && vm.filterShop) {
            Object.assign(data, {
              shop_main_pageid: vm.filterShop.shop_main_pageid,
              app: vm.filterApp
            })
          }

          if (['toacrm'].includes(vm.selectedBot.theme)) {
            Object.assign(data, {
              limit: vm.size,
              offset: vm.offset
            })

            if (vm.filterStatus !== 'all') {
              data.status = vm.filterStatus
            }

            if (vm.search) {
              Object.assign(data, { search: vm.search })
            }
          }

          api.getOrderSummary(data, function (error, response) {
            if (error) {
              console.error(error)
              // vm.$store.dispatch('loading')
              reject()
              return
            }
            if (response.data) {
              if (!noclearselect) {
                vm.clearSelectAll()
              }

              vm.total = parseInt(response.total)
              resolve(response)
            }
            // vm.$store.dispatch('loading')
          })
        })
      }
    },
    convertOrder(response) {
      this.summary = response.data
        ? response.data.map((el) => {
            const shippingType = el.shippingtype ? el.shippingtype.split('|')[0] : el.shippingtype
            return {
              ...el,
              virual_timestamp: moment().format('x'),
              shippingtype: shippingType
            }
          })
        : []

      if (this.filterStatus == 'all') {
        this.badge = {
          all: response.all || response.total,
          total: response.all || response.total,
          canceled: response.canceled,
          ordered: response.ordered,
          paid: response.paid,
          shipped: response.shipped,
          pending: response.pending,
          waiting: response.waiting
        }
      }
    },
    onChangeStatus: function (index) {
      let vm = this
      vm.updateOrder(index, 'send')
    },
    updateOrder: async function (id, payload, callback) {
      let vm = this
      vm.$store.dispatch('loading')
      let order = vm.summary.find(function (element) {
        return element.id === id
      })
      let data = JSON.parse(JSON.stringify(order))

      if (payload == 'send' && data.status == 'canceled') data.sendreason = true
      else if (payload == 'send' && data.status == 'shipped') data.sendtrackingstatus = true

      if (data) {
        if (this.selectedBot.theme == 'lookchingiant') {
          data.shippingtype = ''
        }
        if (['dtac-gaming'].includes(this.selectedBot.type)) {
          data.nameaddress = ''
          data.trackingno = ''
          data.shippingtype = ''
        }
        api.editOrderSummary(data, function (error) {
          if (error) {
            console.error(error)
            vm.$store.dispatch('loading')
            return
          }

          order.virual_timestamp = moment().format('x')
          if (callback) {
            callback()
          }

          vm.$store.dispatch('loading')
          if (payload != 'send') {
            vm.onRefresh()
          }
        })
      }
    },
    async exportOrderSummary(type) {
      let vm = this
      let orders = []
      let filter = this.filterOrders
      let filename = ''
      var json = []

      $.each(filter, function (index, val) {
        if (val.status == vm.filterStatus) {
          orders.push(val)
        } else if (vm.filterStatus == 'all') {
          orders.push(val)
        }
      })

      orders = orders.filter((val) => {
        if (vm.filterCategoryStatus == 'all') return true
        else return val.livename == vm.filterCategoryStatus
      })

      if (vm.$aston.astonpages.includes(vm.selectedBot.pageid)) {
        $.each(orders, function (index, val) {
          let note = val.note
          if (typeof note !== 'undefined' && note != null && note !== '') {
            try {
              note = JSON.parse(note)
            } catch (error) {
              return
            }
            var name, phone, address, zipcode, sku, sku2, sa_link, amount, proname
            name = phone = address = zipcode = sku = sku2 = sa_link = amount = proname = ''
            if (typeof note.name !== 'undefined') name = note.name
            if (typeof note.phone !== 'undefined') phone = note.phone
            if (typeof note.address !== 'undefined') address = note.address
            if (typeof note.zipcode !== 'undefined') zipcode = note.zipcode
            if (typeof note.sku !== 'undefined') {
              sku = note.sku
              var temp = sku.split('+')
              if (temp.length == 2) {
                sku = temp[0]
                sku2 = temp[1]
              }
            }
            if (typeof note.amount !== 'undefined') amount = note.amount
            // if (typeof note.proname !== 'undefined') proname = note.proname
            proname = val.productdetail
            if (typeof note.sa_link !== 'undefined' && !note.sa_link.includes('hatbot')) {
              sa_link = note.sa_link
            } else {
              if (
                vm.selectedBot.pageid == '1231805606976542' ||
                vm.selectedBot.pageid == '391365474996527' ||
                vm.selectedBot.pageid == '2105726733070683'
              ) {
                if (typeof note.sa_link !== 'undefined')
                  sa_link = note.sa_link + '-dc-bee-' + proname
              } else {
                if (typeof note.sa_link !== 'undefined') sa_link = note.sa_link + proname
              }
            }
            json.push({
              ลำดับ: index + 1,
              'Order No.': val.id,
              'ชื่อ-สกุล*': name,
              เบอร์โทร: phone,
              ที่อยู่: address,
              รหัสไปรษณีย์: zipcode,
              ไอดีสินค้า: sku,
              ไอดีสินค้า2: sku2,
              ชื่อสินค้า: proname,
              'ลิงค์ทำ order': sa_link,
              ราคาสินค้า: numeral(amount).format('0,0.00').toString(),
              หมายเหตุ: val.remark
            })
          }
        })
        filename = 'order_summary_' + moment().format('YYYY_MM_DD')
      } else {
        if (type == 'merge') {
          orders = orders.sort(
            (a, b) =>
              moment(a.timestamp).format('YYYYMMDDHHmm') -
              moment(b.timestamp).format('YYYYMMDDHHmm')
          )

          $.each(orders, function (index, val) {
            var productdetail = ''
            let products = undefined
            try {
              products = JSON.parse(val.productdetail)
            } catch (error) {
              products = val.productdetail
            }

            try {
              if (typeof products == 'object' && products.length > 0) {
                products.map(function (product) {
                  productdetail +=
                    product.name +
                    ' x ' +
                    product.quantity +
                    ` SKU:${product.sku ? product.sku : '- '}` +
                    (product.option ? ' (' + product.option + ')' : '') +
                    ' : ' +
                    (product.price > 0 ? '฿' + product.price : 'Free') +
                    '\r\n'
                })
              } else {
                productdetail = val.productdetail
              }
            } catch (error) {
              productdetail = val.productdetail
            }

            var realname = val.nameaddress ? val.nameaddress.split(' , ') : ''
            var shippingType = ''
            try {
              var jsondata = JSON.parse(val.shippingtype)
              if (jsondata.type) {
                shippingType = jsondata.type
              }
            } catch (error) {
              if (val.shippingtype.includes('other')) {
                var shipping = vm.shippingOptions.find((el) => {
                  return el.name == val.shippingtype
                })
                shippingType = shipping ? shipping[4] : val.shippingtype
              } else {
                shippingType = val.shippingtype
              }
            }

            var couponcode = ''
            if (val.jsonvalue) {
              try {
                jsondata = JSON.parse(val.jsonvalue)
                couponcode = jsondata.promocode ? jsondata.promocode : ''
              } catch (error) {
                console.error(error)
              }
            }

            json.push({
              'Order No.': val.id,
              Products: productdetail,
              Remark: val.remark,
              'Social Name': val.first_name + ' ' + val.last_name,
              'Real Name': realname.length > 1 ? realname[0] : '',
              Address: val.nameaddress,
              Price: numeral(val.amount).format('0,0.00').toString(),
              Shipping: shippingType ? vm.$t(shippingType) : '',
              'Tracking No.': val.trackingno,
              'Created Date': moment(val.timestamp).format('DD/MM/YYYY HH:mm'),
              Status:
                vm.$store.getters.getPackage == 'premium' && val.userstatus ? val.userstatus : '-',
              Tags: vm.$store.getters.getPackage == 'premium' && val.tags ? val.tags : '-',
              SKU: products[0].sku ? `${products[0].sku}` : '-',
              Quantity: val.allquantity ? `${val.allquantity}` : '-',
              'Customer Code': couponcode,
              'Payment method': val.payment ? val.payment : '-'
            })
          })

          filename = 'zwizshop'
        } else if (type == 'kerry') {
          orders = orders.sort(
            (a, b) =>
              moment(a.timestamp).format('YYYYMMDDHHmm') -
              moment(b.timestamp).format('YYYYMMDDHHmm')
          )
          $.each(orders, function (index, val) {
            var postcode = ''
            var phone = ''
            var name = ''
            var address = val.nameaddress.split(' , ')
            var result_address = ''

            var shippingType = ''
            try {
              var jsondata = JSON.parse(val.shippingtype)
              if (jsondata.type) {
                shippingType = jsondata.type
              }
            } catch (error) {
              shippingType = val.shippingtype
            }
            var price =
              shippingType == 'cod_charge' ? numeral(val.amount).format('0,0').toString() : 0
            if (address.length > 0) {
              name = address[0]
              address.splice(0, 1)
              phone = address[address.length - 1]
              address.splice(address.length - 1, 1)
              result_address = address.join('')
              var postcode_regex = /[0-9]{5}/g
              if (result_address.match(postcode_regex)) {
                var postcode_match = result_address.match(postcode_regex)
                if (postcode_match.length > 0) {
                  postcode = postcode_match[0]
                  result_address = result_address.replace(postcode, '')
                }
              }
            }

            json.push({
              No: index + 1,
              'Recipient Name': name,
              'Mobile No.': phone,
              Email: '',
              'Address #1': result_address,
              'Address #2': '',
              'Zip Code': postcode,
              'COD Amt (Baht)': price,
              Remark: val.remark
            })
          })
          filename = 'zwizshop_kerry'
        } else if (type == 'sap') {
          vm.sapFormat(filter)
          return false
        } else {
          // csvContent +=
          //   'Order No.,Status,SKU,Products,Price,Remark,Social Name,Real Name,Address,Price,Shipping,Tracking No.,Created Date,Status,Tags,Quantity' +
          //   '\r\n'
          orders = orders.sort(
            (a, b) =>
              moment(b.timestamp).format('YYYYMMDDHHmm') -
              moment(a.timestamp).format('YYYYMMDDHHmm')
          )
          $.each(orders, function (index, val) {
            var productdetail = []
            let products = undefined
            try {
              products = JSON.parse(val.productdetail)
            } catch (error) {
              products = val.productdetail
            }

            try {
              if (typeof products == 'object' && products.length > 0) {
                products.map(function (product) {
                  productdetail.push({
                    name: product.name ? product.name : '',
                    quantity: product.quantity,
                    sku: product.sku ? product.sku : '',
                    option: product.option ? ' (' + product.option + ')' : '',
                    price: product.price > 0 ? product.price : 'Free',
                    cart_remark: product.cart_remark,
                    unit_price: product.unit_price || product.price || null,
                    sales_unit_price: product.sales_unit_price || product.price || null,
                    discount_per_unit: product.discount_per_unit
                  })
                })
              } else {
                productdetail[0] = val.productdetail
              }
            } catch (error) {
              productdetail[0] = val.productdetail
            }

            var realname = val.nameaddress ? val.nameaddress.split(' , ') : ''
            var shippingType = ''
            try {
              var jsondata = JSON.parse(val.shippingtype)
              if (jsondata.type) {
                shippingType = jsondata.type
              }
            } catch (error) {
              if (val.shippingtype && val.shippingtype.includes('other')) {
                var shipping = vm.shippingOptions.find((el) => {
                  return el.name == val.shippingtype
                })
                shippingType = shipping ? shipping[4] : val.shippingtype
              } else {
                shippingType = val.shippingtype
              }
            }

            var couponcode = ''
            if (val.jsonvalue) {
              try {
                jsondata = JSON.parse(val.jsonvalue)
                couponcode = jsondata.promocode ? jsondata.promocode : ''
              } catch (error) {
                console.error(error)
              }
            }

            let fullAddress = ''
            let customerName = ''
            try {
              var nameaddress = JSON.parse(val.nameaddress)
              customerName = nameaddress.name
              fullAddress = `${nameaddress.name} ${nameaddress.address} เขต${nameaddress.district} แขวง${nameaddress.subDistrict} จังหวัด${nameaddress.province} ${nameaddress.postCode} เบอร์โทรศัพท์${nameaddress.phoneNumber}`
            } catch (error) {
              fullAddress = val.nameaddress
            }

            let contactInfo = {
              name: '',
              address: '',
              phone_number: ''
            }
            if (vm.isTremendous) {
              if (fullAddress) {
                const splitAddress = fullAddress.split(',')
                if (splitAddress.length > 0) {
                  contactInfo.name = customerName || splitAddress[0]
                  contactInfo.address = splitAddress.slice(1, -1).join()
                  contactInfo.phone_number = splitAddress[splitAddress.length - 1].trim()
                }
              }
            }

            const userid = val.userid
            let userid_split = null
            try {
              userid_split = val.app == 'line' ? userid.split('__')[0] : userid
            } catch (error) {
              userid_split = userid
            }
            let row = null
            if (vm.selectedBot.theme === 'seagull') {
              const amount = Number(val.amount)
              const shippingcharge = Number(val.shippingcharge)
              const subTotal = numeral(amount - shippingcharge)
                .format('0,0.00')
                .toString()

              const fullPrice =
                Number(productdetail[0].unit_price) * Number(productdetail[0].quantity)
              const salePrice = Number(productdetail[0].sales_unit_price)
              const discount = numeral(fullPrice - salePrice)
                .format('0,0.00')
                .toString()
              row = {
                'Date & Time': moment(val.timestamp).format('DD/MM/YYYY HH:mm'),
                ...(['nestle'].includes(vm.selectedBot.type) ? { pageuid: userid_split } : {}),
                'Order Number': val.id,
                'Status Order': val.status,
                SKU: typeof productdetail[0] == 'string' ? products.sku : productdetail[0].sku,
                Products:
                  typeof productdetail[0] == 'string'
                    ? products.name
                    : `${productdetail[0].name}${
                        productdetail[0].option ? ` ${productdetail[0].option}` : ''
                      }`,
                'SKU Amount':
                  typeof productdetail[0] == 'string'
                    ? productdetail[0].quantity
                    : products[0].quantity,
                'Unit price':
                  typeof productdetail[0] == 'string'
                    ? ''
                    : numeral(productdetail[0].unit_price).format('0,0.00'),
                'Sale price': productdetail[0]
                  ? numeral(productdetail[0].sales_unit_price).format('0,0.00')
                  : 0,
                Discount: discount,
                'Shipping fee': numeral(val.shippingcharge).format('0,0.00').toString(),
                'Sub Total': subTotal,
                Total: numeral(val.amount).format('0,0.00').toString(),
                Shipping: shippingType ? vm.$t(shippingType) : '',
                'Tracking No.': val.trackingno,
                'Shippop Tracking No.': vm.selectedBot.shippop_status
                  ? val.shippop_tracking_code
                  : '-',
                Remark: val.remark != null ? val.remark : '',
                Channel: val.app,
                'Social Name': ['tcp'].includes(vm.selectedBot.theme)
                  ? val.social_name
                  : `${val.first_name} ${val.last_name}`,
                ...(vm.isTremendous
                  ? {
                      'Address Name': contactInfo.name,
                      Address: contactInfo.address,
                      'Phone Number': contactInfo.phone_number
                    }
                  : {
                      Address: fullAddress
                    }),
                ...(vm.selectedBot.theme === 'tcp'
                  ? {
                      Page: vm.filterTcpPage ? vm.filterTcpPage.page_name : vm.selectedBot.pagename
                    }
                  : {}),

                Phone: val.phone_number,
                Status:
                  vm.$store.getters.getPackage == 'premium' && val.userstatus
                    ? val.userstatus
                    : '-',
                'Customer Tags':
                  vm.$store.getters.getPackage == 'premium' && val.tags ? val.tags : '-',
                'Customer Code': couponcode,
                ...(['tero'].includes(vm.selectedBot.type)
                  ? {
                      'Payment Type':
                        jsondata && jsondata.payment_channel ? jsondata.payment_channel : ''
                    }
                  : {})
              }
            } else {
              row = {
                'Date & Time': moment(val.timestamp).format('DD/MM/YYYY HH:mm'),
                ...(['nestle'].includes(vm.selectedBot.type) ? { pageuid: userid_split } : {}),
                'Order Number': val.id,
                'Status Order': val.status,
                'Total per Order': val.allquantity ? `${val.allquantity}` : '-',
                SKU: typeof productdetail[0] == 'string' ? products.sku : productdetail[0].sku,
                Products:
                  typeof productdetail[0] == 'string'
                    ? products.name
                    : `${productdetail[0].name}${
                        productdetail[0].option ? ` ${productdetail[0].option}` : ''
                      }`,
                'SKU Amount':
                  typeof productdetail[0] == 'string'
                    ? productdetail[0].quantity
                    : products[0].quantity,
                Price:
                  typeof productdetail[0] == 'string'
                    ? ''
                    : numeral(productdetail[0].price).format('0,0.00'),
                'Shipping fee': numeral(val.shippingcharge).format('0,0.00').toString(),
                Discount: numeral(val.discount).format('0,0.00').toString(),
                Total: numeral(val.amount).format('0,0.00').toString(),
                Shipping: shippingType ? vm.$t(shippingType) : '',
                'Tracking No.': val.trackingno,
                'Shippop Tracking No.': vm.selectedBot.shippop_status
                  ? val.shippop_tracking_code
                  : '-',
                ...(vm.isYasale
                  ? {
                      'Tax ID': val.remark != null ? val.remark : ''
                    }
                  : {
                      Remark: val.remark != null ? val.remark : ''
                    }),
                Channel: val.app,
                'Social Name': ['tcp'].includes(vm.selectedBot.theme)
                  ? val.social_name
                  : `${val.first_name} ${val.last_name}`,
                ...(vm.isTremendous
                  ? {
                      'Address Name': contactInfo.name,
                      Address: contactInfo.address,
                      'Phone Number': contactInfo.phone_number
                    }
                  : {
                      Address: fullAddress
                    }),
                ...(vm.selectedBot.theme === 'tcp'
                  ? {
                      Page: vm.filterTcpPage ? vm.filterTcpPage.page_name : vm.selectedBot.pagename
                    }
                  : {}),

                Status:
                  vm.$store.getters.getPackage == 'premium' && val.userstatus
                    ? val.userstatus
                    : '-',
                'Customer Tags':
                  vm.$store.getters.getPackage == 'premium' && val.tags ? val.tags : '-',
                'Customer Code': couponcode,
                ...(['tero'].includes(vm.selectedBot.type)
                  ? {
                      'Payment Type':
                        jsondata && jsondata.payment_channel ? jsondata.payment_channel : ''
                    }
                  : {}),
                ...(vm.isYasale && {
                  'RTR code': val.custom_attribute_json ? val.custom_attribute_json.rtr_code : ''
                })
              }
            }

            if (vm.isTremendous) {
              Object.assign(row, {
                'Link Google Map': val.user_link
              })
              Object.assign(row, {
                Latitude: val.address_lat ? val.address_lat : '-'
              })
              Object.assign(row, {
                Longitude: val.address_long ? val.address_long : '-'
              })
              Object.assign(row, {
                'Google link by Latitude and Longitude':
                  val.address_long && val.address_lat
                    ? `https://maps.google.com/?q=${val.address_lat},${val.address_long}`
                    : '-'
              })
            }

            if (vm.selectedBot.theme == 'runkan') {
              Object.assign(row, {
                'Run status': val.runkanstatus == 'SUCCESS' ? 'วิ่งสำเร็จ' : 'วิ่งไม่สำเร็จ'
              })
            }

            if (vm.selectedBot.theme === 'cityfresh') {
              Object.assign(row, {
                'Shipping Date': val.shipping_date
                  ? moment(val.shipping_date).format('DD/MM/YYYY')
                  : '-',
                'Shipping Time': val.shipping_time
              })
            }

            if (vm.isTremendous) {
              Object.assign(row, {
                'Shipping Date': val.shipping_date
                  ? moment(val.shipping_date).format('DD/MM/YYYY HH:mm')
                  : '-',
                'Payment Method': val.payment ? val.payment : '-',
                'Address Name': contactInfo.name
              })
            }

            if (['dtac-gaming'].includes(vm.selectedBot.type)) {
              Object.assign(row, {
                'User ID': val.userid
              })
            }

            if (
              [
                '148831989096546',
                '1229692217050821',
                '135565533158593',
                '488563718210335',
                '799590883441878'
              ].includes(vm.selectedBot.pageid)
            ) {
              var remarksplit = []
              try {
                remarksplit = val.remark.split(';;')
                row.Remark = remarksplit[0]
                row['Bank Name'] = remarksplit.length > 1 ? remarksplit[1] : ''
              } catch (error) {
                row.Remark = val.remark
              }
            }

            if (
              ['176922345693076', '809510349133469', '103876431747147'].includes(
                vm.selectedBot.pageid
              )
            ) {
              var order = productdetail.find((el) => {
                return el.cart_remark != '' || el.cart_remark != null
              })
              if (order) {
                row['ขายโดย'] = order.cart_remark
              }
            }

            json.push({
              ...row,
              ...(vm.isNestle ? { 'Order Tags': val.order_tags } : {})
            })

            if (productdetail.length > 1) {
              productdetail.map((detail, dindex) => {
                if (dindex != 0) {
                  if (vm.selectedBot.theme == 'seagull') {
                    const fullPrice = Number(detail.unit_price) * Number(detail.quantity)
                    const salePrice = Number(detail.sales_unit_price)
                    const discount = numeral(fullPrice - salePrice)
                      .format('0,0.00')
                      .toString()
                    json.push({
                      'Date & Time': moment(val.timestamp).format('DD/MM/YYYY HH:mm'),
                      'Order Number': val.id,
                      'Status Order': val.status,
                      SKU: detail.sku,
                      Products: `${detail.name}${detail.option ? ` ${detail.option}` : ''}`,
                      'Unit price': numeral(detail.unit_price).format('0,0.00'),
                      'Sale price': numeral(detail.sales_unit_price).format('0,0.00'),
                      Discount: discount,
                      'Shipping fee': '-',
                      'Sub Total': '-',
                      Total: '-',
                      Shipping: shippingType ? vm.$t(shippingType) : '',
                      'Tracking No.': val.trackingno,
                      'Shippop Tracking No.': vm.selectedBot.shippop_status
                        ? val.shippop_tracking_code
                        : '-',
                      Remark: val.remark != null ? val.remark : '',
                      Channel: val.app,
                      'Social Name': ['tcp'].includes(vm.selectedBot.theme)
                        ? val.social_name
                        : `${val.first_name} ${val.last_name}`,
                      Address: fullAddress,
                      Phone: val.phone_number,
                      Status:
                        vm.$store.getters.getPackage == 'premium' && val.userstatus
                          ? val.userstatus
                          : '-',
                      'Customer Tags':
                        vm.$store.getters.getPackage == 'premium' && val.tags ? val.tags : '-',
                      'Customer Code': couponcode,
                      'SKU Amount': detail.quantity,
                      ...(['nestle'].includes(vm.selectedBot.type)
                        ? {
                            'Shipping fee': numeral(val.shippingcharge).format('0,0.00').toString(),
                            Discount: numeral(val.discount).format('0,0.00').toString(),
                            Shipping: shippingType ? vm.$t(shippingType) : '',
                            'Tracking No.': val.trackingno,
                            'Shippop Tracking No.': vm.selectedBot.shippop_status
                              ? val.shippop_tracking_code
                              : '-',
                            Remark: val.remark != null ? val.remark : '',
                            Channel: val.app,
                            'Social Name': val.first_name + ' ' + val.last_name,
                            'Real Name': realname.length > 1 ? realname[0] : '',
                            Address: fullAddress,
                            Status:
                              vm.$store.getters.getPackage == 'premium' && val.userstatus
                                ? val.userstatus
                                : '-',
                            'Customer Tags':
                              vm.$store.getters.getPackage == 'premium' && val.tags
                                ? val.tags
                                : '-',
                            'Customer Code': couponcode
                          }
                        : {}),
                      ...(vm.isTremendous
                        ? {
                            SKU: detail.sku,
                            'Shipping fee': numeral(val.shippingcharge).format('0,0.00').toString(),
                            Discount: numeral(val.discount).format('0,0.00').toString(),
                            Total: numeral(val.amount).format('0,0.00').toString(),
                            Shipping: shippingType ? vm.$t(shippingType) : '',
                            'Tracking No.': val.trackingno,
                            'Shippop Tracking No.': vm.selectedBot.shippop_status
                              ? val.shippop_tracking_code
                              : '-',
                            Remark: val.remark != null ? val.remark : '',
                            Channel: val.app,
                            'Social Name': val.first_name + ' ' + val.last_name,
                            'Address Name': contactInfo.name,
                            Address: contactInfo.address,
                            'Phone Number': contactInfo.phone_number,
                            Status:
                              vm.$store.getters.getPackage == 'premium' && val.userstatus
                                ? val.userstatus
                                : '-',
                            'Customer Tags':
                              vm.$store.getters.getPackage == 'premium' && val.tags
                                ? val.tags
                                : '-',
                            'Customer Code': couponcode,
                            'Shipping Date': val.shipping_date
                              ? moment(val.shipping_date).format('DD/MM/YYYY HH:mm')
                              : '-',
                            'Payment Method': val.payment ? val.payment : '-'
                          }
                        : {})
                    })
                  } else {
                    json.push({
                      ...(['nestle'].includes(vm.selectedBot.type)
                        ? {
                            'Date & Time': moment(val.timestamp).format('DD/MM/YYYY HH:mm'),
                            'Status Order': val.status,
                            pageuid: userid_split
                          }
                        : {}),
                      ...(vm.isTremendous
                        ? {
                            'Date & Time': moment(val.timestamp).format('DD/MM/YYYY HH:mm'),
                            'Order Number': val.id,
                            'Status Order': val.status,
                            'Total per Order': val.allquantity ? `${val.allquantity}` : '-'
                          }
                        : {}),
                      SKU: detail.sku,
                      Products: `${detail.name}${detail.option ? ` ${detail.option}` : ''}`,
                      Price: numeral(detail.price).format('0,0.00'),
                      'SKU Amount': detail.quantity,
                      ...(['nestle'].includes(vm.selectedBot.type)
                        ? {
                            'Shipping fee': numeral(val.shippingcharge).format('0,0.00').toString(),
                            Discount: numeral(val.discount).format('0,0.00').toString(),
                            Shipping: shippingType ? vm.$t(shippingType) : '',
                            'Tracking No.': val.trackingno,
                            'Shippop Tracking No.': vm.selectedBot.shippop_status
                              ? val.shippop_tracking_code
                              : '-',
                            Remark: val.remark != null ? val.remark : '',
                            Channel: val.app,
                            'Social Name': val.first_name + ' ' + val.last_name,
                            'Real Name': realname.length > 1 ? realname[0] : '',
                            Address: fullAddress,
                            Status:
                              vm.$store.getters.getPackage == 'premium' && val.userstatus
                                ? val.userstatus
                                : '-',
                            'Customer Tags':
                              vm.$store.getters.getPackage == 'premium' && val.tags
                                ? val.tags
                                : '-',
                            'Customer Code': couponcode
                          }
                        : {}),
                      ...(vm.isTremendous
                        ? {
                            SKU: detail.sku,
                            'Shipping fee': numeral(val.shippingcharge).format('0,0.00').toString(),
                            Discount: numeral(val.discount).format('0,0.00').toString(),
                            Total: numeral(val.amount).format('0,0.00').toString(),
                            Shipping: shippingType ? vm.$t(shippingType) : '',
                            'Tracking No.': val.trackingno,
                            'Shippop Tracking No.': vm.selectedBot.shippop_status
                              ? val.shippop_tracking_code
                              : '-',
                            Remark: val.remark != null ? val.remark : '',
                            Channel: val.app,
                            'Social Name': val.first_name + ' ' + val.last_name,
                            'Address Name': contactInfo.name,
                            Address: contactInfo.address,
                            'Phone Number': contactInfo.phone_number,
                            Status:
                              vm.$store.getters.getPackage == 'premium' && val.userstatus
                                ? val.userstatus
                                : '-',
                            'Customer Tags':
                              vm.$store.getters.getPackage == 'premium' && val.tags
                                ? val.tags
                                : '-',
                            'Customer Code': couponcode,
                            'Shipping Date': val.shipping_date
                              ? moment(val.shipping_date).format('DD/MM/YYYY HH:mm')
                              : '-',
                            'Payment Method': val.payment ? val.payment : '-'
                          }
                        : {})
                    })
                  }
                }
              })
            }
          })
          filename = 'zwizshop'
        }
      }
      var dataWS = null
      if (type == 'kerry') dataWS = XLSX.utils.json_to_sheet(json, { origin: 'A8' })
      else dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
    },
    sapFormat(data) {
      var companyCode = '100'
      var systemCode = '10'
      var batchNo = moment().format('YYYYMMDD') + '001'
      var lotNo = companyCode + systemCode + batchNo

      var prefix_filename = ''

      switch (this.selectedBot.pageid) {
        case '488563718210335': // moniga
          prefix_filename = 'MG_'
          break
        case '135565533158593': // monobo
          prefix_filename = 'MB_'
          break
        case '1229692217050821': // Kardas
          prefix_filename = 'KD_'
          break
        case '148831989096546': // Rubber Soul
          prefix_filename = 'RBS_'
          break

        default:
          break
      }

      // U_CompanyCode	U_SystemCode	U_TransBatchNo	U_LotNo	DocNum	NumAtCard	U_Status	DocDate	DocDueDate	DocTime	Comments	U_Channel	CardCode	CardName	U_SocialName	Address	U_Shipping	U_TrackingNo	DocCur	DocRate	DiscPrcnt	DocTotal	PaidSum	U_TrnsfDate

      // invoice header
      var invoiceHeader = data.map((el) => {
        var realname = el.nameaddress ? el.nameaddress.split(' , ') : ''
        var shippingType = ''
        try {
          var jsondata = JSON.parse(el.shippingtype)
          if (jsondata.type) {
            shippingType = jsondata.type
          }
        } catch (error) {
          shippingType = el.shippingtype
        }
        var tel =
          realname.length > 1
            ? realname[realname.length - 1].replace(/-/g, '').replace(/ /g, '')
            : ''
        try {
          tel = tel.replace('+66', '0').match(/[0-9]+/g)[0]
        } catch (error) {
          tel = ''
        }
        var remark = ''
        try {
          remark = el.remark ? el.remark.replace(/[|]/g, '').replace(/\n/g, '') : ''
          remark = remark && remark.split(';;').length > 0 ? remark.split(';;')[0] : ''
        } catch (error) {
          remark = el.remark ? el.remark.replace(/\n/g, '').replace(/|/g, '') : ''
        }

        return [
          companyCode,
          systemCode,
          batchNo,
          lotNo,
          el.id,
          el.id,
          el.status,
          moment(el.timestamp).format('YYYYMMDD'),
          moment(el.timestamp).format('YYYYMMDD'),
          moment(el.timestamp).format('HHmm'),
          remark,
          el.app,
          tel,
          realname.length > 1 ? realname[0] : '',
          el.first_name + ' ' + el.last_name,
          el.nameaddress.replace(/\n/g, ' ').replace(/[|]/g, ''),
          shippingType ? this.$t(shippingType) : '',
          el.trackingno,
          'THB',
          1,
          el.discount,
          numeral(el.amount).format('0.00').toString(),
          numeral(el.amount).format('0.00').toString(),
          ''
        ].join('|')
      })

      var invoiceDetails = data.map((el) => {
        var productdetail = []
        let products = undefined
        try {
          products = JSON.parse(el.productdetail)
        } catch (error) {
          products = el.productdetail
        }
        try {
          if (typeof products == 'object' && products.length > 0) {
            productdetail = products.map(function (product) {
              return {
                name: product.name ? product.name : '',
                quantity: product.quantity,
                sku: product.sku ? product.sku : '',
                option: product.option ? ' (' + product.option + ')' : '',
                price: product.price > 0 ? product.price : 'Free'
              }
            })
          } else {
            productdetail[0] = el.productdetail
          }
        } catch (error) {
          productdetail[0] = el.productdetail
        }

        var result = productdetail.map((detail, dindex) => {
          return [
            companyCode,
            systemCode,
            batchNo,
            lotNo,
            el.id,
            dindex,
            detail.sku,
            detail.name + detail.option,
            detail.quantity,
            numeral(detail.price / detail.quantity)
              .format('0.00')
              .toString(),
            numeral(detail.price).format('0.00').toString(),
            '',
            '',
            '',
            '',
            '',
            ''
          ].join('|')
        })

        return result.join('\n')
      })

      var paymentHeader = data.map((el) => {
        var realname = el.nameaddress ? el.nameaddress.split(' , ') : ''

        var bankname = ''
        try {
          bankname = el.remark && el.remark.split(';;').length > 1 ? el.remark.split(';;')[1] : ''
        } catch (error) {
          bankname = ''
        }
        var tel =
          realname.length > 1
            ? realname[realname.length - 1].replace(/-/g, '').replace(/ /g, '')
            : ''
        try {
          tel = tel.replace('+66', '0').match(/[0-9]+/g)[0]
        } catch (error) {
          tel = ''
        }
        return [
          companyCode,
          systemCode,
          batchNo,
          lotNo,
          el.id,
          moment(el.timestamp).format('YYYYMMDD'),
          moment(el.timestamp).format('HHmm'),
          tel,
          realname.length > 1 ? realname[0] : '',
          'THB',
          1,
          '',
          numeral(el.amount).format('0.00').toString(),
          '',
          '',
          '',
          '',
          bankname,
          '',
          '',
          ''
        ].join('|')
      })

      var paymentDetails = data.map((el) => {
        let products = undefined

        var productdetail = []
        try {
          products = JSON.parse(el.productdetail)
        } catch (error) {
          products = el.productdetail
        }

        try {
          if (typeof products == 'object' && products.length > 0) {
            productdetail = products.map(function (product) {
              return {
                name: product.name ? product.name : '',
                quantity: product.quantity,
                sku: product.sku ? product.sku : '',
                option: product.option ? ' (' + product.option + ')' : '',
                price: product.price > 0 ? product.price : 'Free'
              }
            })
          } else {
            productdetail[0] = el.productdetail
          }
        } catch (error) {
          productdetail[0] = el.productdetail
        }

        var result = productdetail.map((detail, dindex) => {
          return [
            companyCode,
            systemCode,
            batchNo,
            lotNo,
            el.id,
            dindex,
            el.id,
            numeral(detail.price).format('0.00').toString()
          ].join('|')
        })

        return result.join('\n')
      })
      var invoiceHeader_Header = [
        'U_CompanyCode',
        'U_SystemCode',
        'U_TransBatchNo',
        'U_LotNo',
        'DocNum',
        'NumAtCard',
        'U_Status',
        'DocDate',
        'DocDueDate',
        'DocTime',
        'Comments',
        'U_Channel',
        'CardCode',
        'CardName',
        'U_SocialName',
        'Address',
        'U_Shipping',
        'U_TrackingNo',
        'DocCur',
        'DocRate',
        'DiscPrcnt',
        'DocTotal',
        'PaidSum',
        'U_TrnsfDate'
      ]
      invoiceHeader_Header = invoiceHeader_Header.join('|')
      invoiceHeader.unshift(invoiceHeader_Header)
      this.exportText(
        invoiceHeader.join('\n'),
        `${prefix_filename}${companyCode}_${systemCode}_${batchNo}_${lotNo}_OINV_H`
      )

      var invoiceDetails_header = [
        'U_CompanyCode',
        'U_SystemCode',
        'U_TransBatchNo',
        'U_LotNo',
        'DocNum',
        'LineNum',
        'ItemCode',
        'Dscription',
        'Quantity',
        'PriceAfVAT',
        'LineTotal',
        'WhsCode',
        'UseBaseUn',
        'OcrCode',
        'OcrCode3',
        'OcrCode4',
        'OcrCode5'
      ]
      invoiceDetails_header = invoiceDetails_header.join('|')
      invoiceDetails.unshift(invoiceDetails_header)
      this.exportText(
        invoiceDetails.join('\n'),
        `${prefix_filename}${companyCode}_${systemCode}_${batchNo}_${lotNo}_INV1_L`
      )

      var paymentHeader_header = [
        'U_CompanyCode',
        'U_SystemCode',
        'U_TransBatchNo',
        'U_LotNo',
        'DocNum',
        'DocDate',
        'DocTime',
        'CardCode',
        'CardName',
        'DocCurrency',
        'DocRate',
        'CashSum',
        'TransferSum',
        'CreditSum',
        'CheckSum',
        'CashAccount',
        'CheckAccount',
        'TransferAccount',
        'BankCode',
        'BankAccount',
        'Remarks'
      ]
      paymentHeader_header = paymentHeader_header.join('|')
      paymentHeader.unshift(paymentHeader_header)
      this.exportText(
        paymentHeader.join('\n'),
        `${prefix_filename}${companyCode}_${systemCode}_${batchNo}_${lotNo}_ORCT_H`
      )

      var paymentDetails_header = [
        'U_CompanyCode',
        'U_SystemCode',
        'U_TransBatchNo',
        'U_LotNo',
        'ParentKey',
        'LineNum',
        'DocEntry',
        'PaidSum'
      ]
      paymentDetails_header = paymentDetails_header.join('|')
      paymentDetails.unshift(paymentDetails_header)
      this.exportText(
        paymentDetails.join('\n'),
        `${prefix_filename}${companyCode}_${systemCode}_${batchNo}_${lotNo}_RCT2_L`
      )
    },
    exportTrackingOrder() {
      let result = []
      if (['ordered', 'paid'].includes(this.filterStatus)) {
        result =
          this.filterStatus == 'ordered'
            ? this.filterOrders.filter((f) => f.status == 'ordered')
            : this.filterOrders.filter((f) => f.status == 'paid')
      } else {
        // Export only reviewing and paid
        result = this.filterOrders.filter((f) => f.status == 'paid' || f.status == 'ordered')
      }

      if (result.length == 0) {
        this.$swal.fire('ไม่พบข้อมูล', 'ไม่สามารถ export ได้', 'warning')
      }

      result = result.map((d) => {
        return { orderNumber: d.id, trackingNo: d.trackingno, note: '' }
      })

      let hasTrackingResult = result.filter((f) => f.trackingNo != '' || f.trackingNo != null)
      if (hasTrackingResult.length > 0) {
        hasTrackingResult.forEach((d) => {
          let remarkIndex = d.trackingNo.indexOf('หมายเหตุ')
          let trackingno = ''
          let remark = ''
          if (remarkIndex != -1) {
            trackingno = d.trackingNo.substring(0, remarkIndex)
            remark = d.trackingNo.substring(remarkIndex)
            remark = remark.substring(10)
          }
          result.find((f) => f.orderNumber == d.orderNumber).trackingNo = trackingno
          result.find((f) => f.orderNumber == d.orderNumber).note = remark
        })
      }

      let dataWs = XLSX.utils.json_to_sheet(result)
      dataWs.A1.v = 'Order Number'
      dataWs.B1.v = 'Tracking No.'
      dataWs.C1.v = 'Note'
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWs)
      let exportDay = moment().format('DD/MM/YYYY')
      XLSX.writeFile(wb, 'Export Order No. ' + exportDay.toString() + '.xlsx')
    },
    async importTrackingOrder(payload) {
      this.$store.dispatch('loading')
      api.saveOrdersTracking(payload, (err, result) => {
        if (err) {
          this.$swal.fire('ข้อผิดพลาด', 'ไม่สามารถดำเนินการได้', 'warning')
        } else {
          if (result.responsecode == 200) {
            this.IsImportTrackingSuccess = true
            setTimeout(() => {
              this.IsImportTrackingSuccess = false
              this.onRefresh()
            }, 2000)
          } else {
            this.$swal.fire('ข้อผิดพลาด', 'ไม่สามารถดำเนินการได้', 'warning')
          }
        }
        this.$store.dispatch('loading')
      })
    },
    async importOrderTracking(data) {
      try {
        const response = await orderApi.putUpdateOrderTracking({
          pageId: this.selectedBot.pageid,
          data: data
        })
        handleResponse(response)

        if (response && response.status === 200) {
          return response
        } else {
          return null
        }
      } catch (error) {
        handleApiError(error)
        return null
      }
    },
    onClickUploadButton() {
      document.getElementById('importFile').click()
    },
    async handleImportFile(event) {
      if (event.target.files[0] === undefined) {
        return
      }

      //check file size
      const file_size = 26214400
      if (event.target.files[0].size > file_size) {
        this.$swal.fire('ข้อผิดพลาด', 'การอัพโหลดไฟล์ถูกจำกัดเพียง 25 MB เท่านั้น', 'warning')
        return
      }
      //check file type
      const file_type = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
      if (!file_type.includes(event.target.files[0].type)) {
        this.$swal.fire('ข้อผิดพลาด', 'การอัพโหลดไฟล์รองรับไฟล์นามสกุล XLSX เท่านั้น', 'warning')
        return
      }

      const file = event.target.files[0]
      let data = await this.ExcelToJson(file)
      if (data) {
        data = data.map((d) => {
          return {
            id: Number(Object.values(d)[0]),
            trackNo: Object.values(d)[1].toString(),
            note: Object.values(d)[2]
          }
        })
        let payload = {
          orders: data
        }

        try {
          let response = null
          this.$store.dispatch('loading')
          if (['tero'].includes(this.selectedBot.theme)) {
            response = await this.importOrderTracking(payload)
          } else {
            Object.assign(payload, { pageid: this.selectedBot.pageid })
            response = await this.importTrackingOrder(payload)
          }
          this.$store.commit('CLEAR_LOADING')

          if (response) {
            this.$swal.fire({
              type: 'success',
              text: 'อัพโหลดไฟล์สำเร็จ'
            })
          }
        } catch (error) {
          this.$store.commit('CLEAR_LOADING')
          console.error(error)
        }
      } else {
        this.$swal.fire('ข้อผิดพลาด', 'ไม่สามารถดำเนินการได้', 'warning')
      }
    },
    async ExcelToJson(file) {
      return new Promise((resolve) => {
        var reader = new FileReader()
        reader.onload = (e) => {
          var data = e.target.result
          var workbook = XLSX.read(data, {
            type: 'binary'
          })
          workbook.SheetNames.forEach((sheetName) => {
            // Here is your object
            var XL_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName])
            var json_object = JSON.stringify(XL_row_object)
            resolve(JSON.parse(json_object))
          })
        }

        reader.onerror = function (ex) {
          console.error(ex)
        }
        reader.readAsBinaryString(file)
      })
    },
    handleChangeShop() {
      this.onRefresh()
    },
    async shipWithZortout() {
      const vm = this
      let selected = vm.summary.filter((el) => {
        return (
          this.cbAll.includes(el.id) &&
          ['Payment สำเร็จ'].includes(el.status) &&
          el.zortout_ref == null
        )
      })
      selected = selected.map((item) => item.id)
      if (selected.length == 0) {
        await vm.$swal({
          title: vm.$t('send_with_zortout_paid_only'),
          type: 'warning',
          confirmButtonText: vm.$t('Confirm')
        })
      } else if (this.addresses.length == 0) {
        await vm.$swal({
          title: vm.$t('send_with_zortout_have_address'),
          type: 'warning',
          confirmButtonText: vm.$t('Confirm')
        })
        this.showEditAddress = true
      } else {
        vm.createOrderZortout(selected)
      }
    },
    async createOrderZortout(selected) {
      try {
        this.$store.dispatch('loading')
        let response = await this.post(`zortout/${this.selectedBot.pageid}/create-order`, {
          order_ids: selected
        })
        if (response.data.message == 'SUCCESS') {
          await this.checkZortoutCreateOrder(selected)
          this.zortoutOrder.show = true

          this.zortoutOrder.status = 'PENDING'
          this.zortoutOrder.interval = setInterval(async () => {
            let responseCreateOrder = await this.checkZortoutCreateOrder(selected)
            if (this.zortoutOrder.status == 'SUCCESS') {
              this.$store.dispatch('loading')
              if (this.zortoutOrder.interval) clearInterval(this.zortoutOrder.interval)
              await this.$swal.fire({
                title: this.$t('Success'),
                type: 'success',
                confirmButtonText: this.$t('Confirm'),
                showCancelButton: false,
                reverseButtons: true
              })
              window.location.reload()
            } else if (this.zortoutOrder.status == 'FAILED') {
              let dataFailed = []
              responseCreateOrder.map((item) => {
                if (item.status === 'FAILED') {
                  dataFailed.push(item.orderid)
                }
              })

              this.$store.dispatch('loading')
              if (this.zortoutOrder.interval) clearInterval(this.zortoutOrder.interval)

              await this.$swal.fire({
                title: this.$t('Error'),
                text: `ไม่สามารถจัดส่งออเดอร์ดังต่อไปนี้ได้ ${dataFailed.toString()}`,
                type: 'error',
                confirmButtonText: this.$t('Confirm'),
                showCancelButton: false,
                reverseButtons: true
              })
            }
          }, 5000)
        }
      } catch (error) {
        if (error.response && error.response.data.message == 'IMPORT_LIMIT_EXCEEDED') {
          this.$store.dispatch('loading')
          await this.$swal.fire({
            title: this.$t('ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้งหลังจาก 10 นาที'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        } else {
          this.$store.dispatch('loading')
          await this.$swal.fire({
            title: this.$t('Something went wrong. Please try it again later'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            showCancelButton: false,
            reverseButtons: true
          })
        }
      }
    },
    async checkZortoutCreateOrder(selected) {
      try {
        let response = await this.post(`zortout/${this.selectedBot.pageid}/check-create-order`, {
          order_ids: selected
        })
        if (response.data.message == 'SUCCESS') {
          let data = response.data.result
          let isPending = data.some((i) => i.status.includes('PENDING'))
          if (isPending) {
            this.zortoutOrder.status = 'PENDING'
          } else {
            let isFailed = data.some((i) => i.status.includes('FAILED'))
            if (isFailed) {
              this.zortoutOrder.status = 'FAILED'
            } else {
              this.zortoutOrder.status = 'SUCCESS'
            }
          }
        }
        return response.data.result
      } catch (error) {
        console.error(error)
      }
    },
    async importUpdateOrdersToacrm(payload) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await toaCrmApi.importUpdateOrders({ config: payload })
        vm.$store.dispatch('loading')

        if (response && response.status === 200) {
          vm.IsImportTrackingSuccess = true
          setTimeout(() => {
            vm.IsImportTrackingSuccess = false
            vm.onRefresh()
          }, 2000)
        } else {
          vm.$swal.fire('ข้อผิดพลาด', 'ไม่สามารถดำเนินการได้', 'warning')
        }
      } catch (error) {
        console.error(error)
      }
    },
    async handleImportFileToacrm(event) {
      const vm = this
      try {
        if (event.target.files[0] === undefined) {
          return
        }

        //check file size
        const file_size = 26214400
        if (event.target.files[0].size > file_size) {
          vm.$swal.fire('ข้อผิดพลาด', 'การอัพโหลดไฟล์ถูกจำกัดเพียง 25 MB เท่านั้น', 'warning')
          return
        }
        //check file type
        const file_type = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
        if (!file_type.includes(event.target.files[0].type)) {
          vm.$swal.fire('ข้อผิดพลาด', 'การอัพโหลดไฟล์รองรับไฟล์นามสกุล XLSX เท่านั้น', 'warning')
          return
        }
        const file = event.target.files[0]
        let data = await vm.ExcelToJson(file)
        if (data) {
          data = data.map((d) => {
            return {
              order_id: Number(Object.values(d)[0]),
              tracking_no: Object.values(d)[1].toString(),
              shipping_type: Object.values(d)[2],
              remark: Object.values(d)[3]
            }
          })

          let payload = {
            page_id: vm.selectedBot.pageid,
            data: data
          }
          await vm.importUpdateOrdersToacrm(payload)
        } else {
          vm.$swal.fire('ข้อผิดพลาด', 'ไม่สามารถดำเนินการได้', 'warning')
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getExportTrackingOrderToacrm() {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          date_from: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
          date_to: moment(vm.selectedDate.end).format('YYYY-MM-DD')
        }

        vm.$store.dispatch('loading')
        const response = await toaCrmApi.exportTrackingOrders({ config: data })
        vm.$store.dispatch('loading')

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    },
    async handleExportTrackingOrderToacrm() {
      const vm = this
      try {
        const tempData = await vm.getExportTrackingOrderToacrm()
        const data = tempData.data.data

        if (data === null) {
          vm.$swal.fire('ไม่พบข้อมูล', 'ไม่สามารถ export ได้', 'warning')
          return
        }

        const dataWS = data.map((el) => {
          return {
            id: el.id,
            trackingno: el.trackingno,
            shippingtype: el.shippingtype,
            remark: el.remark
          }
        })

        const heading = [['Order No.', 'Tracking No.', 'Delivery', 'Remark']]
        const wb = XLSX.utils.book_new()
        const ws = XLSX.utils.json_to_sheet([])
        XLSX.utils.sheet_add_aoa(ws, heading)
        XLSX.utils.sheet_add_json(ws, dataWS, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, ws)
        XLSX.writeFile(wb, `toacrm-shipping-orders.xlsx`)
      } catch (error) {
        console.error(error)
      }
    },
    async handleSelectedOrdersShippingDateUpdate(date) {
      try {
        const response = await tremendousApi.putOrderSummaryShippingDate({
          data: {
            page_id: this.selectedBot.pageid,
            shipping_date: moment(date).format('YYYY-MM-DD'),
            order_ids: this.cbAll
          }
        })

        if (response.status === 200) {
          this.onRefresh()
        }
      } catch (error) {
        this.$swal.fire('ข้อผิดพลาด', 'ไม่สามารถดำเนินการได้', 'warning')
        console.error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ecommerce-order-summary.vue